<template>
  <div class="page-content conmon-top behavior-analyse higher-search-analyse">
    <div class="base-input ovf-hd"
         style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col style="width: 300px"
                class="search-nav-left">
          <i class="el-icon-search analyse-edit-name-i"
             style="font-weight: bold;">
          </i>
          <span v-if="editId !== undefined"
                :title="editSingleNameShow"
                v-show="showSingleName === false"
                class="order-list-search-span analyse-edit-name">
            {{ editSingleNameShow }}
          </span>
          <el-input :maxlength="50"
                    v-show="showSingleName"
                    class="stockInputs"
                    type="text"
                    v-model="editSingleName"
                    auto-complete="off"
                    placeholder="">
          </el-input>
          <img v-show="editId !== undefined &&
            showSingleName === false"
               style="cursor: pointer;width: 14px;height: 14px;margin-top: 17px;margin-left: 10px"
               src="../../assets/images/icn-binaji.png"
               class="analyse-edit-name-btn"
               @click="openEditName" />
          <i @click="saveSingleNameOnly"
             v-show="showSingleName"
             class="el-icon-circle-check-outline"
             style="color: #1980FF!important;font-size: 16px!important;cursor: pointer;margin-left: 0">
          </i>
          <span v-if="editId === undefined"
                class="order-list-search-span">
            分析条件
          </span>
        </el-col>
        <el-col style="width: calc(100% - 300px);"
                class="search-nav-right">
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="hide">
            {{ hide? '收起查询':'展开查询' }}
          </el-button>
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="!hide">
            {{ hide? '收起查询':'展开查询' }}
          </el-button>
          <i v-if="hide === true"
             class="el-icon-arrow-up search-open-close-i" @click="hide=!hide">
          </i>
          <i v-if="hide === false"
             class="el-icon-arrow-down search-open-close-i" @click="hide=!hide">
          </i>
          <el-button v-if="isAdd === 'true'"
                     class="search-btn-new"
                     type="primary"
                     size="small"
                     @click="backAction"
                     style="margin-right:16px">
            返回
          </el-button>
          <el-button class="search-btn-new"
                     style="margin-right: 12px;"
                     v-if="editId !== undefined&&butsObj.save_as"
                     type="primary"
                     size="small"
                     @click="otherSave">
            另存为
          </el-button>
          <el-button class="search-btn-new"
                     v-if="editId !== undefined&&butsObj.save"
                     type="primary"
                     size="small"
                     style="margin-right: 12px"
                     @click="editSave">
            保存
          </el-button>
          <el-button class="search-btn-new"
                     style="margin-right: 12px;"
                     v-if="editId === undefined&&butsObj.save"
                     type="primary"
                     size="small"
                     @click="openSave">
            保存
          </el-button>
          <el-button class="search-btn-new"
                     type="primary"
                     size="small"
                     @click="startSearch"
                     style="margin-right: 12px">
            查询
          </el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide"
             class="search-flod-content common-search-formtype"
             style="padding: 0 0 4px 0;border: none">
          <el-form :inline="true"
                   :model="formInline"
                   class="search-content-item behavior-form"
                   label-width="85px"
                   style="width: 100%">
            <el-row style="padding-top: 7px">
              <el-form-item label="受众类型：">
                <el-select @change="modelIdChange"
                           filterable
                           v-model="formInline.modelId"
                           placeholder="受众类型："
                           class="customer-manage-search-item analyse-people"  @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                  <el-option v-for="item in audiencesModelOptions"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="分析行为："
                            class="behavior-label"
                            style="width: 100%;margin-top: 10px">
                <div class="behavior-content"
                     v-for="(item, index) in behaviors"
                     :key="index">
                  <div class="behavior-name">
                    <span style="display: inline-block;width: 72px;text-align: right">行为名称：</span>
                    <el-input @change="checkBehaviorName(item, index)"
                              v-model="item.behaviorName"
                              placeholder="请输入行为名"></el-input>
                  </div>
                  <!--受众事件选择-->
                  <span style="display: inline-block;width: 72px;text-align: right;margin-top: 10px">行为：
                  </span>
                  <!--级联选择器-->
                  <el-cascader @change="changeEvent($event,item,index)"
                               ref="select"
                               filterable
                               :options="eventsSelectOptions"
                               v-model="item.event"
                               class="first-attr first-cascader special-high-search-fir aud-first-attr">
                  </el-cascader>
                  <div class="remove-btn"
                       style="font-size: 15px;color: #ccc"
                       @click="removeBehaviorItem(index)"
                       v-if="behaviors.length > 1">
                    <i class="el-icon-error"
                       title="删除当前条件">
                    </i>
                  </div>
                  <!--限制-->
                  <div class="action-select">
                    <el-row class="action-select-row"
                            style="height: 32px">
                      <el-checkbox lass="behavior-limit-time"
                                   @change="limitTimeChange(item)"
                                   v-model="item.generation_time">
                        限制周期时间
                      </el-checkbox>
                      <el-checkbox @change="changeLimitEventAttr(item)"
                                   v-model="item.eventLimitAttr">
                        限制事件属性
                      </el-checkbox>
                    </el-row>
                    <el-row class="action-select-row"
                            v-if="item.generation_time === true">
                      <el-col class="action-select-row-title"
                              style="margin-left: 54px;width: 70px;line-height: 40px">
                        周期时间:
                      </el-col>
                      <el-col style="width: calc(100% - 124px);">
                        <!--周期类型-->
                        <el-select @change="chooseGenerationTimeType"
                                   @blur="clearGenerationTime(item)"
                                   class="ifSelect"
                                   v-model="item.generation_time_type"
                                   placeholder="请选择查询内容">
                          <el-option v-for="i in generation_time_types"
                                     :key="i.value"
                                     :label="i.label"
                                     :value="i.value">
                          </el-option>
                        </el-select>
                        <!--周期关系-->
                        <el-select @change="chooseGenerationTimeRelation(item)"
                                   class="ifSelect"
                                   v-model="item.generation_time_relation"
                                   placeholder="请选择查询内容">
                          <el-option v-for="i in generation_time_relations"
                                     :key="i.value"
                                     :label="i.label"
                                     :value="i.value">
                          </el-option>
                        </el-select>
                        <!--周期值非区间-->
                        <el-select class="ifSelect"
                                   v-if="item.generation_time_relation !== 'gtele'"
                                   v-model="item.generation_time_value"
                                   placeholder="请选择查询内容">
                          <el-option v-for="i in item.generation_time_values"
                                     :key="i.value"
                                     :label="i.label"
                                     :value="i.value">
                          </el-option>
                        </el-select>
                        <!--周期值区间-->
                        <el-select @change="chooseGenerationTimeValuesStart(item)"
                                   @visible-change="clearGenerationTimeValuesEnd(item)"
                                   class="ifSelect"
                                   v-if="item.generation_time_relation === 'gtele'"
                                   v-model="item.generation_time_value_start"
                                   placeholder="请选择查询内容">
                          <el-option v-for="i in item.generation_time_values_start"
                                     :key="i.value"
                                     :label="i.label"
                                     :value="i.value">
                          </el-option>
                        </el-select>
                        <span v-if="item.generation_time_relation === 'gtele'">
                          -
                        </span>
                        <el-select @change="chooseGenerationTimeValuesEnd"
                                   v-if="item.generation_time_relation === 'gtele'"
                                   class="ifSelect"
                                   v-model="item.generation_time_value_end"
                                   placeholder="请选择查询内容">
                          <el-option v-for="i in item.generation_time_values_end"
                                     :key="i.value"
                                     :label="i.label"
                                     :value="i.value">
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <div v-if="item.eventLimitAttr"
                         style="padding-left: 55px;">
                      <el-row class="behaviors-limit action-select-row limit-attr"
                              style="line-height: 40px">
                        <el-col :span="24"
                                v-for="(itemAttr, ai) in item.eventAttrOptions"
                                :key="ai">
                          <el-col :span="12"
                                  class="action-select-row-title">
                            <span style="padding-left: 0">
                              <span style="padding-left: 0"
                                    v-if="ai === 0">事件属性:</span>
                              <span style="padding-left: 0"
                                    v-if="ai !== 0">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </span>
                          </el-col>
                          <!--事件属性名字-->
                          <el-select filterable
                                     @change="changeLimitRelation(item, itemAttr)"
                                     class="event-son-input arrowPositionSelect"
                                     v-model="itemAttr.attributeContent"
                                     placeholder="请选择事件属性" @visible-change="visibleChangeOne1" @focus="focusWayOne1" ref="selectOne1">
                            <el-option v-for="k in item.eventAttributeList"
                                       :key="k.attr_identity"
                                       :label="k.attr_name"
                                       :value="k.attr_identity">
                            </el-option>
                          </el-select>
                          <!--相对关系-->
                          <el-select class="event-son-input arrowPositionSelect limit-relation"
                                     v-model="itemAttr.attributeRelation"
                                     placeholder="相对关系">
                            <el-option v-for="k in itemAttr.relationOptions"
                                       :key="k.value"
                                       :label="k.label"
                                       :value="k.value">
                            </el-option>
                          </el-select>
                          <!-- 地理位置，三级联动-->
                          <el-cascader v-if="itemAttr.attributeContent === 'address' &&
                                   (itemAttr.attributeRelation === 'equal' || itemAttr.attributeRelation === 'not_equal')"
                                       filterable
                                       class="first-attr behavior-dimension arrowPositionSelect"
                                       size="large"
                                       :options="addressOptions"
                                       v-model="itemAttr.attributeValue"
                                       @change="updateAddress"></el-cascader>

                          <!--值-->
                          <el-select class="event-son-input arrowPositionSelect limit-relation"
                                     filterable
                                     v-if="itemAttr.attributeRelation !== 'empty' &&
                            itemAttr.attributeRelation !== 'not_empty' &&
                            itemAttr.attributeContent === 'source'"
                                     v-model="itemAttr.attributeValue"
                                     placeholder="选择来源">
                            <el-option v-for="k in itemAttr.sources"
                                       :key="k.value"
                                       :label="k.label"
                                       :value="k.value">
                            </el-option>
                          </el-select>
                          <!-- :fetch-suggestions="querySearchAsync" -->
                          <el-autocomplete v-if="itemAttr.attr_type === 'dictionary' && itemAttr.attr_identity !== 'source'"
                                           v-model="itemAttr.attributeValue"
                                           @focus="setItemAttr(item, itemAttr)"
                                           placeholder="请输入内容"
                                           @select="handleSelect">
                          </el-autocomplete>
                          <el-input maxlength="200"
                                    @input="updateValue(item)"
                                    v-if="itemAttr.attributeRelation !== 'empty' &&
                            itemAttr.attr_type !== 'dictionary' &&
                            itemAttr.attributeRelation !== 'not_empty' &&
                            itemAttr.attributeContent !== 'source' &&
                            itemAttr.attr_type === 'txt'"
                                    v-model="itemAttr.attributeValue"
                                    placeholder="请输入限制内容">
                          </el-input>
                          <el-input-number @input="updateValue(item)"
                                           :min="1"
                                           :max="100000000"
                                           controls-position="right"
                                           placeholder="请输入次数"
                                           class="event-son-input font-size-14"
                                           v-if="itemAttr.attributeRelation !== 'empty' &&
                            itemAttr.attributeRelation !== 'gtele' &&
                            itemAttr.attributeRelation !== 'not_empty' &&
                            itemAttr.attr_type === 'money'"
                                           v-model="itemAttr.attributeValue">
                          </el-input-number>
                          <el-input-number @input="updateValue(item)"
                                           :min="1"
                                           :max="100000000"
                                           controls-position="right"
                                           placeholder="请输入次数"
                                           class="event-son-input font-size-14"
                                           v-if="
                              itemAttr.attributeRelation !== 'empty' &&
                              itemAttr.attributeRelation !== 'gtele' &&
                              itemAttr.attributeRelation !== 'not_empty' &&
                              itemAttr.attr_type === 'number'"
                                           v-model="itemAttr.attributeValue">
                          </el-input-number>
                          <el-input-number @input="updateValue(item)"
                                           :min="1"
                                           :max="100000000"
                                           controls-position="right"
                                           placeholder="请输入次数"
                                           class="event-son-input font-size-14"
                                           v-if="itemAttr.attributeRelation !== 'empty' &&
                            itemAttr.attributeRelation === 'gtele' &&
                            itemAttr.attributeRelation !== 'not_empty' &&
                            itemAttr.attr_type === 'money'"
                                           v-model="itemAttr.attributeValueStart">
                          </el-input-number>
                          <span v-if="itemAttr.attributeRelation !== 'empty' &&
                            itemAttr.attributeRelation === 'gtele' &&
                            itemAttr.attributeRelation !== 'not_empty' &&
                            itemAttr.attr_type === 'money'">
                            -
                          </span>
                          <el-input-number @input="updateValue(item)"
                                           :min="1"
                                           :max="100000000"
                                           controls-position="right"
                                           placeholder="请输入次数"
                                           class="event-son-input font-size-14"
                                           v-if="itemAttr.attributeRelation !== 'empty' &&
                            itemAttr.attributeRelation === 'gtele' &&
                            itemAttr.attributeRelation !== 'not_empty' &&
                            itemAttr.attr_type === 'money'"
                                           v-model="itemAttr.attributeValueEnd">
                          </el-input-number>
                          <div class="remove-btn remove-btn-attribute"
                               @click="removeAttributeItem(item, ai)"
                               v-if="item.eventAttrOptions.length>1">
                            <i class="el-icon-error"
                               title="删除当前条件">
                            </i>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row v-if="item.eventAttrOptions.length < 8 && item.eventAttrOptions.length > 0"
                              class="add-new-terms">
                        <div class="add-new-term-btn add-new-term-btn-attribute"
                             @click="addNewEventAttribute(item)">
                          <i class="el-icon-plus"></i>
                          添加事件属性限制
                        </div>
                      </el-row>
                    </div>
                  </div>
                </div>
                <div class="add-new-terms"
                     v-if="behaviors.length > 0 && behaviors.length <= 7">
                  <div class="add-new-ter-btn"
                       @click="addNewBehavior">
                    <i class="el-icon-plus"></i>
                    增加一个条件
                  </div>
                </div>
              </el-form-item>
            </el-row>
            <el-row style="margin-top: 10px;margin-bottom: 10px">
              <el-form-item label="分析人群：">
                <el-select filterable
                           v-model="formInline.analyse_people"
                           placeholder="筛选记录"
                           class="customer-manage-search-item"  @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                  <el-option v-for="item in analysePeopleList"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
                <span @click="searchDialogAction">
                  <i class="iconfont icon-shaixuan analyse-search-icon"></i>
                  <div class="op-link"
                       style="margin: 0;font-size: 14px">{{ filterName }}</div>
                </span>
              </el-form-item>
            </el-row>
            <!--分析人群条件显示区域-->
            <el-row class="analyse-search-show"
                    v-show="is_show_analyse_show">
              <div class="search-show-content"
                   style="clear: both">
                <!--左侧总的相对关系-->
                <div class="search-show-allRelationship"
                     style="clear: both">
                  <span class="left-allrelationship-content"
                        style="clear: both"
                        v-if="realAllTerms.termsGroup.length > 1">
                    <span class="big-term-relationship-and big-term-relationship"
                          v-if="realAllTerms.allRelationship === 'and' && realAllTerms.termsGroup.length > 1">且</span>
                    <span class="big-term-relationship-or big-term-relationship"
                          v-if="realAllTerms.allRelationship === 'or' && realAllTerms.termsGroup.length > 1">或</span>
                  </span>
                </div>
                <!--右侧条件组-->
                <div class="search-show-termsGroup">
                  <!--大的条件-->
                  <div v-for="(item, index) in realAllTerms.termsGroup"
                       :key="index"
                       class="big-term-show">
                    <!--小的条件-->
                    <div v-for="(one, i) in item.terms"
                         :key="i"
                         class="small-term-show">
                      <!--第一级-->
                      <span v-if="one.attr === 'attr'"
                            class="term-key-color">
                        受众属性-
                        <!--第二级-->
                        <span v-if="one.attr_label">{{ one.attr_label }}:</span>
                        <!-- 相对关系 -->
                        <span>
                          <span v-if="one.type === 'datePicker' || one.type === 'dateTimePicker'">
                            <span v-if="one.relationship === 'lt'"
                                  class="term-val-color">
                              [早于
                            </span>
                            <span v-if="one.relationship === 'gt'"
                                  class="term-val-color">
                              [晚于
                            </span>
                          </span>
                          <span v-else>
                            <span v-if="one.relationship === 'lt'"
                                  class="term-val-color">[小于
                            </span>
                            <span v-if="one.relationship === 'gt'"
                                  class="term-val-color">[大于
                            </span>
                          </span>
                        </span>
                        <span v-if="one.relationship === 'equal'"
                              class="term-val-color">
                          [等于
                        </span>
                        <span v-if="one.relationship === 'not_equal'"
                              class="term-val-color">
                          [不等于
                        </span>
                        <span v-if="one.relationship === 'contain'"
                              class="term-val-color">
                          [包含
                        </span>
                        <span v-if="one.relationship === 'not_contain'"
                              class="term-val-color">
                          [不包含
                        </span>
                        <span v-if="one.relationship === 'empty'"
                              class="term-val-color">
                          为空
                          <span v-if="one.selectedOptions[1].split('@')[0] === 'addressPicker'">
                            ]
                          </span>
                        </span>
                        <span v-if="one.relationship === 'not_empty'"
                              class="term-val-color">
                          不为空
                          <span v-if="one.selectedOptions[1].split('@')[0] === 'addressPicker'">
                            ]
                          </span>
                        </span>
                        <!--值-->
                        <span v-if="
                          one.selectedOptions[1].split('@')[0] !== 'addressPicker' &&
                          one.selectedOptions[1].split('@')[0] !== 'stage_id' &&
                          one.selectedOptions[1].split('@')[0] !== 'source_id' &&
                          one.selectedOptions[1].split('@')[1] !== 'datePicker' &&
                          one.selectedOptions[1].split('@')[1] !== 'number' &&
                          one.selectedOptions[1].split('@')[1] !== 'addressPicker' &&
                          one.selectedOptions[1].split('@')[1] !== 'dateTimePicker' &&
                          one.value"
                              class="term-val-color">
                          {{ one.value }}]
                        </span>
                        <span v-if="one.type === 'number'"
                              class="term-val-color">
                          <span v-if="one.relationship === 'gtele'">
                            [{{ one.startValue }}至{{ one.endValue }}]]
                          </span>
                          <span v-else>
                            {{ one.value }}]
                          </span>
                        </span>
                        <!-- 当前等级 -->
                        <span v-if="one.type === 'dict' && one.selectedOptions[1].split('@')[0] === 'stage_id'">
                          {{ stageUse[one.value] }}]
                        </span>
                        <span v-if="one.selectedOptions[1].split('@')[0] !== 'addressPicker' &&
                        one.selectedOptions[1].split('@')[0] === 'source_id' &&
                        one.selectedOptions[1].split('@')[1] !== 'datePicker' &&
                        one.selectedOptions[1].split('@')[1] !== 'dateTimePicker'"
                              class="term-val-color">{{ sourceUse[one.value] }}]
                        </span>
                        <span v-if="one.selectedOptions[1].split('@')[1] === 'datePicker'"
                              class="term-val-color">
                          <span v-if="one.relationship === 'gtele'">[{{ one.startValue }}至{{ one.endValue }}]]</span>
                          <span v-else>{{ one.value }}]</span>
                        </span>
                        <span v-if="
                        one.selectedOptions[1].split('@')[1] === 'dateTimePicker'"
                              class="term-val-color">
                          <span v-if="one.relationship === 'gtele'">[{{ one.startValue }}至{{ one.endValue }}]]</span>
                          <span v-else>{{ one.value }}]</span>
                        </span>
                        <span v-if="one.selectedOptions[1].split('@')[1] === 'addressPicker' &&
                        one.relationship !== 'empty' &&
                        one.relationship !== 'not_empty'"
                              class="term-val-color">
                          {{ CodeToText[one.value[0]] }}
                        </span>
                        <span v-if="
                          one.selectedOptions[1].split('@')[1] === 'addressPicker' &&
                          one.relationship !== 'empty' &&
                          one.relationship !== 'not_empty'"
                              class="term-val-color">
                          {{ CodeToText[one.value[1]] }}
                        </span>
                        <span v-if="
                        one.selectedOptions[1].split('@')[1] === 'addressPicker' &&
                        one.relationship !== 'empty' &&
                        one.relationship !== 'not_empty'"
                              class="term-val-color">
                          {{ CodeToText[one.value[2]] }}]
                        </span>
                      </span>
                      <span v-if="one.attr === 'group'"
                            class="term-key-color">
                        {{ one.attr_label }}:
                        <!-- {{divideGroupShow}}---{{one.value[1]}} -->
                        <span class="term-val-color">
                          <span>[{{ divideGroupShow[one.value[1]] }}]</span>
                        </span>
                      </span>
                      <span v-if="one.attr === 'aud_portary'"
                            class="term-key-color">
                        {{ one.attr_label }}:
                        <span v-if="one.relationship === 'contain'"
                              class="term-val-color">[包含</span>
                        <span v-if="one.relationship === 'not_contain'"
                              class="term-val-color">[不包含</span>
                        <span v-if="one.relationship === 'empty'"
                              class="term-val-color">为空
                          <span v-if="one.selectedOptions[1].split('@')[0] === 'addressPicker'">]</span>
                        </span>
                        <span v-if="one.relationship === 'not_empty'"
                              class="term-val-color">不为空
                          <span v-if="one.selectedOptions[1].split('@')[0] === 'addressPicker'">]</span>
                        </span>
                        <span class="term-val-color">
                          {{ one.value }}]
                        </span>
                      </span>
                      <span v-if="one.attr === 'wechat_open_id'"
                            class="term-key-color">
                        {{ one.attr_label }}:
                        <span v-if="one.relationship === 'equal'"
                              class="term-val-color">[等于</span>
                        <span v-if="one.relationship === 'not_equal'"
                              class="term-val-color">[不等于</span>
                        <span v-if="one.relationship === 'empty'"
                              class="term-val-color">为空
                        </span>
                        <span v-if="one.relationship === 'not_empty'"
                              class="term-val-color">[不为空
                        </span>
                        <span class="term-val-color">
                          {{ one.value }}]
                        </span>
                      </span>
                      <span v-if="one.attr === 'event'"
                            class="term-key-color">
                        受众事件- {{ eventsShow[one.selectedOptions[2]] }}
                        <br v-if="one.eventCheckbox1 === true" />
                        <!--限制条件-->
                        <!--起止时间-->
                        <span v-if="one.eventCheckbox1 === true">
                          <span>
                            <span v-if="one.eventCheckbox1 === true &&
                            one.eventCheckbox2 === true">
                              ├─
                            </span>
                            <span v-if="one.eventCheckbox1 === true &&
                            one.eventCheckbox2 === false">
                              └─</span>
                            起止时间：
                            <span class="term-val-color"
                                  v-if="one.eventSearchDateSelect !== 'cstm'">
                              {{ one.start_end_time }}
                            </span>
                            <span class="term-val-color"
                                  v-if="one.eventSearchDateSelect === 'cstm'">{{ one.start_end_time }}: {{ new Date(one.eventSearchDateSelectStart).getTime() / 1000 | formatDate }}至{{ new Date(one.eventSearchDateSelectEnd).getTime() / 1000 | formatDate }}</span>
                          </span>
                        </span>
                        <br v-if="one.eventCheckbox1 === true && one.eventCheckbox2 === true" />
                        <!--发生次数-->
                        <span v-if="one.eventCheckbox2 === true">
                          └─ 发生次数：
                          <span v-if="one.eventSearchTimesSelect === 'equal'"
                                class="term-val-color">[等于</span>
                          <span v-if="one.eventSearchTimesSelect === 'gt'"
                                class="term-val-color">[大于</span>
                          <span v-if="one.eventSearchTimesSelect === 'lt'"
                                class="term-val-color">[小于</span>
                          <span v-if="one.eventSearchTimesSelect === 'gte'"
                                class="term-val-color">[大于等于</span>
                          <span v-if="one.eventSearchTimesSelect === 'lte'"
                                class="term-val-color">[小于等于</span>
                          <span v-if="one.eventSearchTimesSelect === 'gtele'"
                                class="term-val-color">[区间</span>
                          <span v-if="one.eventSearchTimesSelect !== 'gtele'"
                                class="term-val-color">{{ one.happenedTimes }}]</span>
                          <span v-if="one.eventSearchTimesSelect === 'gtele'"
                                class="term-val-color">{{ one.happenedTimes_from }}至{{ one.happenedTimes_to }}]</span>
                        </span>
                      </span>
                      <span v-if="one.attr === 'follow_public'"
                            class="term-key-color">
                        关注公众号-{{ one.attr_label }}
                        <!-- <span
                        class="term-val-color">
                        [{{ wechatUse[one.value] }}]
                      </span> -->
                        <span class="term-val-color"
                              v-for="(itens,i) in one.option"
                              :key="i"
                              v-if="itens.value === one.value">[{{itens.label}}]
                        </span>
                      </span>
                      <span v-if="one.attr === 'customer_kpi'"
                            class="term-key-color">
                        受众关键指标-{{ one.attr_label }}
                        <span v-if="one.relationship === 'equal'"
                              class="term-val-color">
                          [等于
                        </span>
                        <span v-if="one.relationship === 'not_equal'"
                              class="term-val-color">
                          [不等于
                        </span>
                        <span v-if="one.relationship === 'gt'"
                              class="term-val-color">
                          [大于
                        </span>
                        <span v-if="one.relationship === 'lt'"
                              class="term-val-color">
                          [小于
                        </span>
                        <span v-if="one.relationship === 'gte'"
                              class="term-val-color">
                          [大于等于
                        </span>
                        <span v-if="one.relationship === 'lte'"
                              class="term-val-color">
                          [小于等于
                        </span>
                        <span v-if="one.relationship === 'gtele'"
                              class="term-val-color">
                          [区间
                        </span>
                        <span v-if="one.relationship === 'empty'"
                              class="term-val-color">
                          为空
                        </span>
                        <span v-if="one.relationship === 'not_empty'"
                              class="term-val-color">
                          不为空
                        </span>
                        <span v-if="one.relationship !== 'gtele'"
                              class="term-val-color">
                          {{ one.value }}]
                        </span>
                        <span v-if="one.relationship === 'gtele'"
                              class="term-val-color">
                          {{ one.startValue }}至{{ one.endValue }}]
                        </span>
                      </span>
                      <!--小的相对关系-->
                      <span class="samll-relationship-and"
                            v-if="item.inOperator === 'and' && i !== (item.terms.length - 1)">且</span>
                      <span class="samll-relationship-or"
                            v-if="item.inOperator === 'or' && i !== (item.terms.length - 1)">或</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-row>
            <el-row style="margin-bottom: 8px;margin-top: 10px">
              <el-form-item label="分析指标：">
                <div v-for="(one, i) in analyseQuotaData"
                     :key="i"
                     style="float: left">
                  <!--级联选择器-->
                  <el-cascader :options="analyseQuotaOptions"
                               v-model="one.searchQuota"
                               filterable
                               class="first-attr behavior-dimension"
                               @change="changeSearchQuota">
                  </el-cascader>
                  <div class="remove-btn-quota"
                       @click="removeQuotaItem(one,i)"
                       v-if="analyseQuotaData.length > 1"
                       style="float: right;margin: 0 20px 0 10px;cursor: pointer;color: #ccc;font-size: 15px">
                    <i class="el-icon-error"
                       title="删除当前条件"></i>
                  </div>
                </div>
                <div @click="addAnalyseQuota"
                     style="margin: 1px 0 0 12px;height: 34px"
                     class="add-quota-btn"
                     v-if="analyseQuotaData.length < 4">
                  <i class="el-icon-plus"
                     style="color: #1890ff;"></i>
                  <div class="op-link"
                       style="margin: 0;font-size: 14px">添加指标</div>
                </div>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="分析维度：">
                <div v-for="(two, j) in analyseDimensionData"
                     :key="j"
                     style="float: left">
                  <!--级联选择器-->
                  <el-cascader :options="analyseDimensionOptions"
                               v-model="two.dimension"
                               filterable
                               class="first-attr behavior-dimension"
                               @change="changeDimension">
                  </el-cascader>
                  <div class="remove-btn-quota"
                       @click="removeDimensionItem(two, j)"
                       v-if="analyseDimensionData.length > 1"
                       style="font-size: 15px;color: #ccc;float: right;margin: 0 20px 0 10px;cursor: pointer">
                    <i class="el-icon-error"
                       title="删除当前条件"></i>
                  </div>
                </div>
                <div @click="addAnalyseDimension"
                     style="margin: 0 0 0 12px;height: 34px"
                     class="add-quota-btn"
                     v-if="analyseDimensionData.length <= 3">
                  <i class="el-icon-plus"
                     style="color: #1890ff;"></i>
                  <div class="op-link"
                       style="margin: 0;font-size: 14px">添加维度</div>
                </div>
              </el-form-item>
            </el-row>
            <el-row style="margin-bottom: 16px">
              <el-form-item class="behavior-analyse-time"
                            label="分析时间："
                            style="width: 100%">
                <div style="float: left;width: 100%">
                  <el-col :class="gridNum ? 'big-el-col' : 'samll-el-col'">
                    <el-popover placement="right"
                                width="360"
                                popper-class="time-type-popover"
                                v-model="visible2">
                      <div class="time-types">
                        <div @click="chooseTimeType(l)"
                             class="time-types-item"
                             :class="l.label === start_end_time ? 'choosed' : ''"
                             v-for="(l, num) in timeTypes"
                             :key="num">{{ l.label }}</div>
                      </div>
                      <div class="line-time-type"></div>
                      <div class="set-by-yourself"
                           :class="eventSearchDateSelect === 'cstm' ? 'choosed-set-yr' : ''"
                           @click="setTimeYr">
                        <i class="el-icon-time"></i>
                        自定义时间段
                      </div>
                      <div slot="reference"
                           class="choose-start-end">
                        <i class="el-icon-date"></i>
                        {{ start_end_time }}
                      </div>
                    </el-popover>
                  </el-col>
                  <el-col :span="15"
                          v-if="eventSearchDateSelect=='cstm'"
                          style="padding-left:6px;margin-top: 10px">
                    <el-date-picker v-model="eventSearchDateSelectStart"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    class="event-son-input arrowPositionSelect behavior-date-picker"
                                    placeholder="选择时间和日期">
                    </el-date-picker>
                    -
                    <el-date-picker v-model="eventSearchDateSelectEnd"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="judgeDate"
                                    class="event-son-input arrowPositionSelect behavior-date-picker"
                                    placeholder="选择时间和日期">
                    </el-date-picker>
                  </el-col>
                </div>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <div v-loading="loading">
      <!--分析结果-->
      <el-row v-show="showResult"
              class="search-title common-table-top"
              style="border-bottom: none;padding-right: 0">
        <el-col :span="4"
                style="text-align: left;">
          <i class="el-icon-document"
             style="font-weight: bold;">
          </i>
          <span class="order-list-search-span">
            分析结果
          </span>
        </el-col>
        <el-col :span="20"
                class="text-align-right">
          <el-button v-if="showType.table.is_have === true&&butsObj.export"
                     type="primary"
                     @click="exporeAction"
                     class="add-btn"
                     style="float: right;margin-right: 32px">
            导出
          </el-button>
          <!--表格-->
          <i v-if="showType.table.is_have === false"
             style="color: #CDCDCD!important;margin-right: 12px;"
             class="analyse-res-icon iconfont icon-wenbenjieguo-1">
          </i>
          <i v-if="showType.table.is_have === true"
             @click="chooseTable"
             :class="showType.table.choosed ? 'icon-wenbenjieguo-' : 'icon-wenbenjieguo'"
             class="analyse-res-icon iconfont"
             style="cursor: pointer;margin-right: 12px;">
          </i>
          <!--饼-->
          <i v-if="showType.pie.is_have === false"
             style="color: #CDCDCD!important;"
             class="analyse-res-icon iconfont icon-bingzhuangtu-1">
          </i>
          <i v-if="showType.pie.is_have === true"
             @click="choosePie"
             :class="showType.pie.choosed ? 'icon-bingzhuangtu-' : 'icon-bingzhuangtu'"
             class="analyse-res-icon iconfont"
             style="cursor: pointer">
          </i>
          <!--线-->
          <i v-if="showType.line.is_have === false"
             style="color: #CDCDCD!important;"
             class="analyse-res-icon iconfont icon-zhexiantu-">
          </i>
          <i v-if="showType.line.is_have === true"
             @click="chooseLine"
             :class="showType.line.choosed ? 'icon-zhexiantu' : 'icon-zhexiantu-1'"
             class="analyse-res-icon iconfont"
             style="cursor: pointer">
          </i>
          <!--柱-->
          <i v-if="showType.zhu.is_have === false"
             style="color: #CDCDCD!important;"
             class="analyse-res-icon iconfont icon-zhuzhuangjieguo-"></i>
          <i v-if="showType.zhu.is_have === true"
             @click="chooseZhu"
             :class="showType.zhu.choosed ? 'icon-zhuzhuangjieguo' : 'icon-zhuzhuangjieguo-1'"
             class="iconfont analyse-res-icon"
             style="cursor: pointer">
          </i>
          <!--数字-->
          <i v-if="showType.num.is_have === false"
             style="color: #CDCDCD!important;"
             class="analyse-res-icon iconfont icon-shuzijieguo-1"></i>
          <i v-if="showType.num.is_have === true"
             class="iconfont analyse-res-icon"
             @click="chooseNum"
             :class="showType.num.choosed ? 'icon-shuzijieguo-' : 'icon-shuzijieguo'"
             style="cursor: pointer">
          </i>
        </el-col>
      </el-row>
      <!--展示结果-->
      <el-row class="import-data-title">
        <a-locale-provider :locale="zhCN">
          <a-table :pagination=" {
              total: totalCount,
              defaultCurrent: page,
              pageSize: limit,
              showQuickJumper: true,
              showSizeChanger: false,
              showTotal: function (total) { // 设置显示一共几条数据
                return '共 ' + total + ' 条数据'
            }
          }"
                   style="width: calc(100% - 48px);margin: 0 auto"
                   v-if="showType.table.is_have === true &&
            showType.table.choosed === true"
                   :columns="columns"
                   :dataSource="tableData" />
        </a-locale-provider>
        <!--数字-->
        <div class="result-number-wrap"
             v-show="showType.num.is_have === true &&
          showType.num.choosed === true">
          <span>{{ resultNum }}</span>
        </div>
        <!--柱状图-->
        <div class="chart-content"
             v-show="showType.zhu.is_have === true &&
          showType.zhu.choosed === true">
          <div id="chartZhu"
               class="chart1"></div>
        </div>
        <!--折线图-->
        <div class="chart-content"
             v-show="showType.line.is_have === true &&
          showType.line.choosed === true">
          <div id="chartLine"
               class="chart1"></div>
        </div>
        <!--饼图-->
        <div class="chart-content"
             v-show="
          showType.pie.is_have === true &&
          showType.pie.choosed === true">
          <div id="chartPie"
               class="chart1">
          </div>
        </div>
      </el-row>
    </div>
    <!--筛选弹窗-->
    <el-dialog class="cellDialog analyse-dialog"
               title="人群筛选条件"
               :visible.sync="searchDialog"
               width="1090px">
      <higher-search-audiences :modelId="formInline.modelId"
                               :isAnalyse="isAnalyse"
                               class="common-search-formtype customer-manage-higher-search group-item-style high-search-cascader analyse-high-search"
                               :forSonTerms="forSonTerms"
                               v-bind:allRelationship="allRelationship"
                               @change="getAllTerms"
                               @handleStageUse="handleStageUse"
                               style="margin-top: 10px">
      </higher-search-audiences>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   style="margin-left: 20px"
                   @click="searchDialog = false">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   type="primary"
                   @click="confirmSearchTerms"
                   style="margin-right: 32px">确 定</el-button>
      </div>
    </el-dialog>
    <!--保存单图弹窗-->
    <el-dialog class="cellDialog base-dialog saveSingle"
               title="保存单图"
               :visible.sync="saveSingleDialog"
               width="520px">
      <el-form ref="addForm"
               :model="saveForm">
        <el-form-item label="单图名称:"
                      label-width="110">
          <el-input :maxlength="50"
                    class="stockInputs"
                    type="text"
                    v-model="saveForm.name"
                    auto-complete="off"
                    placeholder="输入单图名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="saveSingleDialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   type="primary"
                   style="margin-right: 32px"
                   @click="confirmSave">确 定</el-button>
      </div>
    </el-dialog>
    <!--另存为单图弹窗-->
    <el-dialog class="cellDialog base-dialog saveSingle"
               title="另存为单图"
               :visible.sync="otherSaveSingleDialog"
               width="520px">
      <el-form ref="addForm"
               :model="otherSaveForm">
        <el-form-item label="单图名称:"
                      label-width="110">
          <el-input :maxlength="50"
                    class="stockInputs"
                    type="text"
                    v-model="otherSaveForm.name"
                    auto-complete="off"
                    placeholder="输入单图名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="otherSaveSingleDialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn"
                   type="primary"
                   style="margin-right: 32px"
                   @click="confirmOtherSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCustomerStage, getSourceData, getQrCodeList, getWechatPublicListForNode,
  getMessageListForNode, getBigWheelList, getWePagesListForNode,
  getMemberInterestOrderList, changeMemberInstrestOrderStatus, analyseDimensionEventIdentity,
  exportMemberInterestOrder, getGroupList, fetchAnalyseIdentity
} from '@/api/customer.js'
import HigherSearchAudiences from './../common/higher-search-audiences.vue'
import { behaviorAnalyseSearch, analyseSaveSingle, customerAnalyseSingleEdit, addSingleChartToDashBoard, butonsList, getMenId } from '@/api/analyse.js'
import { getCusTypes, getCusEventList, getCusAttrList, getCusEventGroupList, getCustomerSources, getAudGroupList, getAudGroupGroupList, getAudGroupAndDimension, getCusStageList, getAudHigSearDicList } from '@/api/set.js'
import { Table, LocaleProvider } from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import G2 from '@antv/g2'
import { ANALYSE_SE_QUO_INIT_OPS, BEHAVIOR_DIMENSION_OPS, RELATIONSHIP_OBJ } from './constant'
export default {
  name: 'behaviorAnalyse',
  data () {
    return {
      inputFlagOne: null,
      isAnalyse: true,
      modelId: '',
      addressOptions: regionDataPlus,
      addressValue: '',
      eventsSelectOptions: [],
      divideGroupShow: {},
      eventsShow: {},
      audiencesModelOptions: [],
      dashBoardId: window.localStorage.getItem('dashBoardId'),
      myStorage: window.localStorage,
      g_two_bar_chart: '',
      allRelationship: 'and',
      hasMultiChart: '',
      filterName: '选择人群筛选条件',
      activityUse: [],
      smsUse: [],
      eventsUse: [],
      wepageUse: [],
      sourceUse: {},
      stageUse: {},
      wechatUse: [],
      groupShow: {},
      CodeToText: CodeToText,
      realAllTerms:
      {
        allRelationship: 'and',
        termsGroup:
          [
            {
              inOperator: 'and',
              terms:
                [
                  {
                    attr_label: '',
                    attr: 'attr',
                    relationship: '',
                    relationOptions: [
                      {
                        value: 'equal',
                        label: '等于'
                      }, {
                        value: 'not_equal',
                        label: '不等于'
                      }, {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'not_contain',
                        label: '不包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not_empty',
                        label: '不为空'
                      }
                    ],
                    eventSearchDateSelect: 'yesterday', // 选择受众事件选中起止时间选择框
                    eventSearchDateSelectStart: '',
                    eventSearchDateSelectEnd: '',
                    eventSearchTimesSelect: '', // 选择受众事件选中发生次数选择框
                    eventAttributeOptions: [ // 选择受众事件选中事件属性
                      {
                        attributeSelect: '',
                        attributeRelation: '',
                        attributeValue: ''
                      }
                    ],
                    selectedOptions: ['attr', '']
                  }
                ]
            }
          ]
      },
      is_show_analyse_show: false,
      excelData: [],
      xNames: '',
      yNames: '',
      barWidth: '',
      otherSaveSingleDialog: false,
      showSingleName: false,
      editSingleName: '',
      editSingleNameShow: '',
      queryJson: {},
      editId: '',
      searchTermsAllLocal: {},
      saveForm: {
        name: ''
      },
      otherSaveForm: {
        name: ''
      },
      saveSingleDialog: false,
      xNamePie: '',
      chartDataYPie: [],
      chartDataYBar: [],
      chartDataY: [],
      chartDataX: [],
      showResult: false,
      gridNum: false,
      timeTypes: [
        {
          label: '昨日',
          value: 'yesterday'
        },
        {
          label: '今日',
          value: 'today'
        },
        {
          label: '上周',
          value: 'lastweek'
        },
        {
          label: '本周',
          value: 'thisweek'
        },
        {
          label: '上月',
          value: 'lastmonth'
        },
        {
          label: '本月',
          value: 'thismonth'
        },
        {
          label: '去年',
          value: 'lastyear'
        },
        {
          label: '今年',
          value: 'thisyear'
        },
        {
          label: '近7天',
          value: 'past7day'
        },
        {
          label: '近30天',
          value: 'past30day'
        },
        {
          label: '上线至今',
          value: 'oneline2today'
        }],
      start_end_time: '昨日',
      eventSearchDateSelect: 'yesterday', // 选择受众事件选中起止时间选择框
      eventSearchDateSelectStart: '',
      eventSearchDateSelectEnd: '',
      visible2: false,
      generation_time_type_use: '',
      generation_time_value_start_use: '',
      generation_time_value_end_use: '',
      generation_time_types: [
        {
          label: '每月',
          value: 'month'
        },
        {
          label: '每周',
          value: 'week'
        }
      ],
      generation_time_values: [],
      generation_time_values_start: [],
      generation_time_values_end: [],
      generation_time_value_month: [],
      generation_time_value_week: [],
      qrcodes: [],
      activities: [],
      sms: [],
      wepage: [],
      wechatPublic: [],
      eventAbout: [],
      events: [],
      generation_time_relations: [
        {
          label: '等于',
          value: 'equal'
        },
        {
          label: '不等于',
          value: 'not_equal'
        },
        {
          label: '区间',
          value: 'gtele'
        }
      ],
      behaviors: [
        {
          eventsSelectOptions: [],
          behaviorName: '行为名称1',
          event: ['0@', 'anyone', ''], // 'anyone@none'
          event_about: '',
          original_id: '',
          qrcode: '',
          generation_time_values: [],
          generation_time_type: '',
          generation_time_relation: '',
          generation_time_value: '',
          generation_time_value_start: '',
          generation_time_value_end: '',
          generation_time: false,
          eventLimitAttr: false,
          eventAttributeList: [],
          eventAttributeOptions: [ // 选择受众事件选中事件属性
            {
              attributeSelect: '',
              attributeRelation: '',
              attributeValue: ''
            }
          ],
          generation_time_type_use: '',
          selectedOptions: ['attr', 'realname@input'],
          generation_time_relations: [
            {
              label: '等于',
              value: 'equal'
            },
            {
              label: '不等于',
              value: 'not_equal'
            },
            {
              label: '区间',
              value: 'gtele'
            }
          ],
          eventAttrOptions: [
            {
              attributeContent: '',
              relationOptions: [],
              sources: [],
              eventAttrValueOptions: [],
              attributeRelation: '',
              attr_type: '',
              attrValTimeStart: '',
              attrValTimeEnd: '',
              attributeValueStart: '',
              attributeValueEnd: '',
              attributeValue: ''
            }
          ],
          relationOptions: [
            {
              value: 'equal',
              label: '等于'
            }, {
              value: 'not_equal',
              label: '不等于'
            }, {
              value: 'contain',
              label: '包含'
            }, {
              value: 'not_contain',
              label: '不包含'
            }, {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not_empty',
              label: '不为空'
            }
          ]
        }
      ],
      options: [
        {
          value: 'attr',
          label: '受众属性',
          children: []
        },
        {
          value: 'group',
          label: '群组',
          children: []
        },
        {
          value: 'event',
          label: '受众事件',
          children: []
        },
        {
          value: 'follow_public',
          label: '关注公众号',
          children: []
        },
        {
          value: 'customer_kpi',
          label: '受众关键指标',
          children: [
            {
              label: '受众活跃度',
              value: 'integrate@input',
              option: [],
              identity: 'integrate'
            },
            {
              label: '受众30天活跃度',
              value: 'integrate_thirty_days@input',
              option: [],
              identity: 'integrate_thirty_days'
            },
            {
              label: '受众价值评分',
              value: 'worth_ integrate@input',
              option: [],
              identity: 'worth_ integrate'
            },
            {
              label: '受众资料分',
              value: 'means_ integrate@input',
              option: [],
              identity: 'means_ integrate'
            }
          ]
        }
      ],
      relationOptions: [
        {
          value: 'equal',
          label: '等于'
        }, {
          value: 'not_equal',
          label: '不等于'
        }, {
          value: 'contain',
          label: '包含'
        }, {
          value: 'not_contain',
          label: '不包含'
        }, {
          value: 'empty',
          label: '为空'
        },
        {
          value: 'not_empty',
          label: '不为空'
        }
      ],
      zhCN,
      columns: [],
      chartZhuOneDataArray: [],
      myChartZhu: null,
      myChartLine: null,
      myChartPie: null,
      showType: {
        num: {
          is_have: false,
          choosed: false
        },
        table: {
          is_have: false,
          choosed: false
        },
        pie: {
          is_have: false,
          choosed: false
        },
        line: {
          is_have: false,
          choosed: false
        },
        zhu: {
          is_have: false,
          choosed: false
        }
      },
      resultNum: 13.5625,
      analyseDimensionData: [
        {
          dimension: ['']
        }
      ],
      analyseDimensionOptions: BEHAVIOR_DIMENSION_OPS(),
      analyseQuotaData: [
        {
          searchQuota: ['total_number_people'],
        }
      ],
      analyseQuotaOptions: ANALYSE_SE_QUO_INIT_OPS(),
      personChildren: [], // 分析维度 受众分析-人数下的二级下拉
      formInline: {
        analyse_people: '',
        order_num: '',
        create_time: '',
        vip_card: '',
        truename: '',
        consignee_name: '',
        consignee_number: '',
        status: ''
      },
      searchDialog: false,
      hide: true,
      loading: false,
      tableData: [],
      page: 1,
      limit: 10,
      search: {},
      totalCount: 0,
      analysePeopleList: [],
      analysePeopleListOne: [],
      allTerms: {
        allRelationship: 'and',
        termsGroup: [
          {
            inOperator: 'and',
            terms: [
              {
                attr_label: '',
                attr: 'attr',
                relationship: '',
                relationOptions: [
                  {
                    value: 'equal',
                    label: '等于'
                  }, {
                    value: 'not_equal',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'not_contain',
                    label: '不包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not_empty',
                    label: '不为空'
                  }
                ],
                gridNum: 3,
                visible2: false,
                start_end_time: '昨日',
                happenedTimes: '',
                happenedTimes_from: '',
                happenedTimes_to: '',
                gtele_start: '',
                gtele_end: '',
                value: null,
                qrcode: null,
                eventCheckbox1: false, // 选择受众事件的checkbox
                eventCheckbox2: false,
                eventCheckbox3: false,
                eventSearchDateSelect: 'yesterday', // 选择受众事件选中起止时间选择框
                eventSearchDateSelectStart: '',
                eventSearchDateSelectEnd: '',
                eventSearchTimesSelect: '', // 选择受众事件选中发生次数选择框
                eventAttributeOptions: [ // 选择受众事件选中事件属性
                  {
                    attributeSelect: '',
                    attributeRelation: '',
                    attributeValue: ''
                  }
                ],
                selectedOptions: ['attr', 'realname@input']
              }
            ]
          }
        ]
      },
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              attr_label: '',
              relationship: '',
              relationOptions: [],
              value: null,
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              selectedOptions: ['attr', '']
            }
          ]
        }
      ],
      allRelationshipSearch: '',
      memberLevelList: {},
      checkSameCount: 0,
      isAdd: window.localStorage.getItem('borderDetailsIsAdd'),
      eventIdList: [],
      eventIdObj: {},
      butsObj: { // button按钮列表
        save: false,
        export: false,
        save_as: false
      }
    }
  },
  computed: {
  },
  components: {
    'higher-search-audiences': HigherSearchAudiences,
    ATable: Table,
    ALocaleProvider: LocaleProvider
  },
  watch: {
    modelId (val) {
      // this.load(val)
      this.loadAudGroupGroupList()
    },
  },
  methods: {
    focusWayOne () {
      if (this.inputFlagOne) {
        this.$refs['selectOne'].blur()
      }
    },
    visibleChangeOne (val) {
      setTimeout(()=> {
        this.inputFlagOne = val
      },0)
    },
    focusWayOne1() {
      if (this.inputFlagOne) {
        this.$refs['selectOne1'][0].blur()
      }
    },
    visibleChangeOne1 (val) {
      setTimeout(()=> {
        this.inputFlagOne = val
      },0)
    },
    // 高级查询-受众事件-当前阶段查询
    handleStageUse (optionList) {
      optionList.forEach(({ id, name }) => {
        this.stageUse[id] = name
      })
    },
    searchDialogAction () {
      this.searchDialog = true
      this.forSonTerms.terms[0].eventAttrOptions = []
      this.forSonTerms.terms[0].eventAttrOptions = [{
        attributeContent: '',
        relationOptions: [],
        eventAttrValueOptions: [],
        attributeRelation: '',
        attr_identity: '',
        attrValTimeStart: '',
        attrValTimeEnd: '',
        attributeValue: ''
      }]
    },
    handleSelect () { },
    // 获取受众群组分组列表
    loadAudGroupGroupList () {
      getAudGroupGroupList(this.formInline.modelId, '').then(res => {
        // 处理群组
        if (res.data.code === '200') {
          // 处理之后给翻译用
          for (let i of res.data.result) {
            this.groupShow[i.id] = i.name
          }
          this.groupShow[0] = '全部'
          // 处理给分析人群
          res.data.result.unshift({
            id: '',
            name: '全部'
          })
        }
      })
    },
    // 限制周期时间
    limitTimeChange (item) { },
    loadAudGroupAndDimension () {
      getAudGroupAndDimension(this.formInline.modelId).then(res => {
        if (res.data.code === '200') {
          for (let userGroups of res.data.result.userGroups) {
            this.divideGroupShow[userGroups.id] = userGroups.name
          }
          let data = res.data.result.dimensions
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity
            remainData[i].label = remainData[i].name
          }
          const list = JSON.parse(JSON.stringify(remainData))
          this.analyseDimensionOptions[1].children = remainData
          this.personChildren = list
        }
      })
    },
    initDate () {
      for (var i = 1; i <= 31; i++) {
        this.generation_time_value_month.push({
          value: i,
          label: i + '号'
        })
      }
      this.generation_time_value_month.push({
        label: '最后一天',
        value: 'last'
      })
      let arr = ['一', '二', '三', '四', '五', '六', '日']
      for (let j = 0; j < arr.length; j++) {
        this.generation_time_value_week.push({
          label: '周' + arr[j],
          value: j + 1
        })
      }
    },
    // 获取受众模型的群组列表
    loadAudGroupList () {
      getAudGroupList(this.formInline.modelId, 1, 1000, '', '').then(res => {
        this.analysePeopleList = []
        if (res.data.code === '200') {
          // 分析人群
          this.analysePeopleList.push({
            id: 0,
            name: '全部'
          })
          for (let f of res.data.result.list) {
            this.divideGroupShow[f.id] = f.name
            this.analysePeopleList.push(f)
          }
          this.formInline.analyse_people = 0
        }
      })
    },
    removeAttributeItem (item, ai) {
      item.eventAttrOptions.splice(ai, 1)
    },
    // 添加属性限制
    addNewEventAttribute (item) {
      item.eventAttrOptions.push({
        attributeContent: '',
        relationOptions: [],
        sources: [],
        eventAttrValueOptions: [],
        attributeRelation: '',
        attr_type: '',
        attr_identity: '',
        attrValTimeStart: '',
        attrValTimeEnd: '',
        attributeValue: ''
      })
    },
    // 处理限制事件属性
    changeLimitEventAttr (item) {
      if (item.eventLimitAttr === false) {
        item.eventAttrOptions = [
          {
            attributeContent: '',
            relationOptions: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attr_identity: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValue: ''
          }
        ]
      }
    },
    updateValue (item) {
      // 解决change报错问题`
      if (typeof item !== 'undefined' && typeof item.value !== 'undefined') {
        // 判断属性对相对关系赋值
        item.relationship = ''
        let relationOptions = []
        if (item.selectedOptions[0] === 'attr') {
          /* -------------自定义属性的相对关系------------ */
          // 文本
          if (item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: 'equal',
                label: '等于'
              }, {
                value: 'not_equal',
                label: '不等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'not_contain',
                label: '不包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ]
          }
          // 单个选择列表
          if (item.selectedOptions[1].split('@')[1] === 'select') {
            relationOptions = [
              {
                value: 'equal',
                label: '等于'
              }, {
                value: 'not_equal',
                label: '不等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ]
          }
          // 单个选择列表
          if (item.selectedOptions[1].split('@')[1] === 'dict') {
            relationOptions = [
              {
                value: 'equal',
                label: '等于'
              }, {
                value: 'not_equal',
                label: '不等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ]
          }
          // 时间
          if (item.selectedOptions[1].split('@')[1] === 'datePicker' || item.selectedOptions[1].split('@')[1] === 'dateTimePicker') {
            relationOptions = [
              {
                value: 'equal',
                label: '等于'
              }, {
                value: 'lt',
                label: '早于'
              }, {
                value: 'gt',
                label: '晚于'
              }, {
                value: 'gtele',
                label: '区间'
              }, {
                value: 'empty',
                label: '为空'
              }, {
                value: 'not_empty',
                label: '不为空'
              }
            ]
          }
          // 地址
          if (item.selectedOptions[1].split('@')[1] === 'addressPicker') {
            relationOptions = [
              {
                value: 'equal',
                label: '等于'
              }, {
                value: 'not_equal',
                label: '不等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ]
          }
          // 多个选择列表
          if (item.selectedOptions[1].split('@')[1] === 'multipleSelect') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'not_contain',
                label: '不包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ]
          }
          // 数值
          if (item.selectedOptions[1].split('@')[1] === 'number') {
            relationOptions = [
              {
                value: 'equal',
                label: '等于'
              }, {
                value: 'not_equal',
                label: '不等于'
              }, {
                value: 'gt',
                label: '大于'
              }, {
                value: 'lt',
                label: '小于'
              }, {
                value: 'gtele',
                label: '区间'
              }
            ]
          }
          // 关联模型
          if (item.selectedOptions[1].split('@')[1] === 'model') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'not_contain',
                label: '不包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ]
          }
        }
        if (item.selectedOptions[0] === 'aud_portary') {
          /* -------------自定义属性的相对关系------------ */
          // 文本
          if (item.selectedOptions[1].split('@')[0] === 'tag') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'not_contain',
                label: '不包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ]
          }
        }
        item.relationOptions = relationOptions
        if (item.selectedOptions[0] === 'group') {
          item.value = []
        } else {
          item.value = null
        }
        // item.qrcode = null
        // item.offline_qrcode = null
        // item.template_id = null
        // item.optionOther = null
        // item.qrcodeOptions = null
        // item.templateOption = null
        // item.public_reply_type_all.reply_type = '不限'
        // item.public_reply_type_all.reply_content = null
        // 获取option的选项值
        let str = ''
        if (item.selectedOptions[0] !== 'event') {
          str = item.selectedOptions[1].split('@')
        }
        item.type = str[1]
        for (let one of this.options) {
          for (let i in one.children) {
            // 处理属性的option
            if (one.value === 'attr') {
              if (str[0] === one.children[i].identity) {
                if (str[0] !== 'stage_id' && str[0] !== 'source_id' && str[1] !== 'model') {
                  if (one.children[i].options !== '') {
                    item.option = JSON.parse(one.children[i].options)
                  }
                }
                if (str[0] === 'stage_id' || str[0] === 'source_id') {
                  item.option = one.children[i].option
                }
                if (str[1] === 'model') {
                  let modelId = JSON.parse(one.children[i].options)[0].modelId
                  let identity = JSON.parse(one.children[i].options)[2].identity
                  getMyAboutModelList(modelId, identity, this.queryString).then((res) => {
                    if (res.data.code == 200) {
                      item.option = res.data.result.list
                    }
                  })
                }
                item.attr_label = one.children[i].label
              }
            }
            // 处理事件的attr
            if (one.value === 'event') {
              for (let j of one.children[i].children) {
                if (item.selectedOptions[2] === j.value) {
                  item.eventAttributeList = j.eventAttributeList
                }
              }
            }
            // 处理群组
            if (one.value === 'group') {
              if (str[0] === one.children[i].identity) {
                item.option = one.children[i].option
                item.attr_label = one.children[i].label
              }
            }
            // 处理标签
            if (one.value === 'aud_portary') {
              if (str[0] === one.children[i].identity) {
                item.attr_label = one.children[i].label
              }
            }
          }
        }
      }
      // 传值到父组件
      // let allTerms = {}
      // allTerms.allRelationship = this.outOperator
      // for (let item of this.termsGroup) {
      //   for (let one of item.terms) {
      //     let firAttr = one.selectedOptions[0]
      //     one.attr = firAttr
      //   }
      // }
      // allTerms.termsGroup = this.termsGroup
    },
    // 地理位置
    updateAddress () { },
    changeLimitRelation (item, itemAttr) {
      // eventAttributeList
      console.log(item, 'itemAttr', itemAttr)
      itemAttr.sources = []
      if (itemAttr.attributeContent === 'source') {
        getCustomerSources(1, 0, '').then((res) => {
          if (res.data.code == 200) {
            for (let items of res.data.result.list) {
              items.label = items.name
              items.value = items.id
            }
            itemAttr.sources = res.data.result.list
          }
        })
      }
      // itemAttr.attributeContent
      for (let yi of item.eventAttributeList) {
        if (itemAttr.attributeContent === yi.attr_identity) {
          itemAttr.attr_type = yi.attr_type
          itemAttr.attr_identity = yi.attr_identity
        }
      }
      itemAttr.attributeRelation = ''
      itemAttr.attributeValue = ''
      itemAttr.attrValTimeStart = ''
      itemAttr.attrValTimeEnd = ''
      itemAttr.attributeValueStart = ''
      itemAttr.attributeValueEnd = ''
      if (itemAttr.attributeContent === 'source' || itemAttr.attributeContent === 'address') {
        itemAttr.relationOptions = [
          {
            value: 'equal',
            label: '等于'
          },
          {
            value: 'not_equal',
            label: '不等于'
          },
          {
            value: 'empty',
            label: '为空'
          },
          {
            value: 'not_empty',
            label: '不为空'
          }
        ]
      }
      if (itemAttr.attributeContent === 'source_content' || itemAttr.attributeContent === 'serial_number') {
        itemAttr.relationOptions = [
          {
            value: 'equal',
            label: '等于'
          },
          {
            value: 'not_equal',
            label: '不等于'
          },
          {
            value: 'empty',
            label: '为空'
          },
          {
            value: 'not_empty',
            label: '不为空'
          },
          {
            value: 'contain',
            label: '包含'
          },
          {
            value: 'not_contain',
            label: '不包含'
          }
        ]
      }
      if (itemAttr.attributeContent !== 'source' || itemAttr.attributeContent !== 'source_content' || itemAttr.attributeContent !== 'serial_number') {
        // itemAttr.relationOptions = RELATIONSHIP_OBJ[itemAttr.attr_type]
        if (itemAttr.attr_type === 'txt') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'contain',
              label: '包含'
            },
            {
              value: 'not_contain',
              label: '不包含'
            },
            {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not_empty',
              label: '不为空'
            }
          ]
        }
        if (itemAttr.attr_type === 'money') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'gt',
              label: '大于'
            },
            {
              value: 'gte',
              label: '大于等于'
            },
            {
              value: 'lt',
              label: '小于'
            },
            {
              value: 'lte',
              label: '小于等于'
            },
            {
              value: 'gtele',
              label: '区间'
            }
          ]
        }
        if (itemAttr.attr_type === 'number') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not_empty',
              label: '不为空'
            }
          ]
        }
        if (itemAttr.attr_type === 'dictionary') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            }
          ]
        }
      }
    },
    // 获取受众类型
    loadCusTypes () {
      getCusTypes().then(res => {
        if (res.data.code === '200') {
          this.audiencesModelOptions = res.data.result
          this.formInline.modelId = res.data.result[0].id
          for (let ids of res.data.result) {
            sessionStorage.removeItem(ids.id)
          }
          this.loadAudGroupList()
          this.loadCustomerStage()
          // this.loadCusAttrList()
          this.loadAudGroupGroupList()
          this.loadAudGroupAndDimension()
        }
      })
    },
    loadCusAttrList () {
      getCusAttrList(this.formInline.modelId).then(res => {
        if (res.data.code === '200') {
          let data = res.data.result
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity + '@' + remainData[i].type
            remainData[i].label = remainData[i].name
          }
          this.analyseDimensionOptions[1].children = remainData
          this.personChildren = remainData
        }
      })
    },
    // modelid改变触发
    modelIdChange () {
      this.changeCondition()
      // this.loadCusAttrList()
      this.loadAudGroupList()
      this.loadAudGroupGroupList()
      this.loadAudGroupAndDimension()
    },
    changeCondition () {
      this.analyseDimensionData = [
        {
          dimension: ['']
        }
      ]
      let terms = sessionStorage.getItem(this.formInline.modelId)
      if (terms) {
        this.realAllTerms = JSON.parse(terms)
        this.forSonTerms = JSON.parse(JSON.stringify(this.realAllTerms.termsGroup))
      } else {
        this.forSonTerms = [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                attr_label: '',
                secAttr: '',
                relationship: '',
                relationOptions: [],
                value: null,
                option: [],
                eventAttrOptions: [
                  {
                    attributeContent: '',
                    relationOptions: [],
                    sources: [],
                    eventAttrValueOptions: [],
                    attributeRelation: '',
                    attr_type: '',
                    attrValTimeStart: '',
                    attrValTimeEnd: '',
                    attributeValueStart: '',
                    attributeValueEnd: '',
                    attributeValue: ''
                  }
                ],
                selectedOptions: ['attr', '']
              }
            ]
          }
        ]
      }
      this.realAllTerms.termsGroup = JSON.parse(JSON.stringify(this.forSonTerms))
    },
    // 返回到看板详情
    backAction () {
      this.myStorage.setItem('borderDetailsIsAdd', 'false')
      router.push({ path: '/home/board-list' })
    },
    checkTHis (item) {
    },
    // 开始时间不能大于结束时间
    judgeDate () {
      if (Date.parse(new Date(this.eventSearchDateSelectStart)) >= Date.parse(new Date(this.eventSearchDateSelectEnd))) {
        this.eventSearchDateSelectEnd = ''
        _g.toastMsg('error', '开始时间不能大于等于结束时间')
      }
    },
    // 检测行为名称是否相同
    checkBehaviorName (item, index) {
      this.checkSameCount = 0
      for (let one of this.behaviors) {
        if (this.behaviors.length >= 1 && item.behaviorName !== '') {
          if (item.behaviorName === one.behaviorName) {
            this.checkSameCount++
          }
        }
      }
      if (this.checkSameCount > 1) {
        _g.toastMsg('error', '请勿输入相同行为名称')
        item.behaviorName = ''
      }
    },
    // 确定查询条件
    confirmSearchTerms () {
      // 判断是否为空1
      for (let i in this.allTerms.termsGroup) {
        let item = this.allTerms.termsGroup[i]
        for (let j in item.terms) {
          if (item.terms[j].selectedOptions[0] === 'attr') {
            if (item.terms[j].selectedOptions[1] === '') {
              _g.toastMsg('error', '受众属性-具体属性不能为空')
              // this.$message.error('sssss')
              return
            }
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
          }
          // 判断受众属性是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'attr') {
              // 判断是否是时间且为区间
              if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                if (item.terms[j].relationship === 'gtele') {
                  if (item.terms[j].startValue === '') {
                    _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                    return
                  }
                  if (item.terms[j].endValue === '' || item.terms[j].endValue === null) {
                    _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '受众属性-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断群组是否为空
          if (item.terms[j].attr === 'group') {
            if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
              _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断受众画像标签是否为空
          if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not_empty') {
            if (item.terms[j].attr === 'aud_portary') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                _g.toastMsg('error', '受众画像-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断受众事件是否为空
          if (item.terms[j].attr === 'event') {
            // 限制属性
            if (item.terms[j].eventLimitAttr === true) {
              for (let yi of item.terms[j].eventAttrOptions) {
                if (yi.attributeContent === '') {
                  _g.toastMsg('error', '受众事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                  return
                }
                if (yi.attributeRelation === '') {
                  _g.toastMsg('error', '受众事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                  return
                }
                if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                  if (yi.attributeValue === '') {
                    _g.toastMsg('error', '受众事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                    return
                  }
                }
              }
            }
            // 限制起止时间
            if (item.terms[j].eventLimitTime === true) {
              if (!item.terms[j].eventDateStart || !item.terms[j].eventDateEnd) {
                _g.toastMsg('error', '请选择起止时间')
                return
              }
            }
            // 限制发生次数
            if (item.terms[j].eventCheckbox2 === true) {
              if (item.terms[j].eventSearchTimesSelect === '') {
                _g.toastMsg('error', '请选择发生次数相对关系')
                return
              }
              if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                if (item.terms[j].happenedTimes === '') {
                  _g.toastMsg('error', '发生次数不能为空')
                  return
                }
              }
              if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                  _g.toastMsg('error', '发生次数区间值不能为空')
                  return
                }
              }
            }
          }
          // 判断关注公众号是否为空
          if (item.terms[j].attr === 'follow_public') {
            if (item.terms[j].value === '' || item.terms[j].value === null) {
              _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
              return
            }
          }
          // 判断受众身份是否为空
          if (item.terms[j].attr === 'customer_identity') {
            if (item.terms[j].relationship === '') {
              _g.toastMsg('error', '请选择相对关系')
              return
            }
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '受众身份-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
          }
          // 判断关受众关键指标是否为空
          if (item.terms[j].attr === 'customer_kpi') {
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
              if (item.terms[j].relationship !== 'gtele') {
                if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                  _g.toastMsg('error', '受众关键指标-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              if (item.terms[j].relationship === 'gtele') {
                if (typeof item.terms[j].endValue === 'undefined' || typeof item.terms[j].startValue === 'undefined' || item.terms[j].endValue === '' || item.terms[j].startValue === null || item.terms[j].startValue === '' || item.terms[j].endValue === null) {
                  _g.toastMsg('error', '受众关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                  return
                }
              }
            }
          }
        }
      }
      this.searchDialog = false
      this.is_show_analyse_show = true
      sessionStorage.setItem(this.formInline.modelId, JSON.stringify(this.allTerms))
      this.realAllTerms = JSON.parse(JSON.stringify(this.allTerms))
      this.filterName = '修改人群筛选条件'
    },
    // 确定另存为单图
    confirmOtherSave () {
      // 判断行为
      for (let one of this.behaviors) {
        if (one.behaviorName === '') {
          _g.toastMsg('error', '行为名称不允许为空')
          return
        }
        if (one.generation_time === true) {
          if (one.generation_time_type === '') {
            _g.toastMsg('error', '周期时间类型不允许为空')
            return
          }
          if (one.generation_time_relation === '') {
            _g.toastMsg('error', '周期时间相对关系不允许为空')
            return
          }
          if (one.generation_time_relation !== 'gtele') {
            if (one.generation_time_value === '') {
              _g.toastMsg('error', '周期时间值不允许为空')
              return
            }
          }
          if (one.generation_time_relation === 'gtele') {
            if (one.generation_time_value_start === '' || one.generation_time_value_end === '') {
              _g.toastMsg('error', '周期时间区间值不允许为空')
              return
            }
          }
        }
      }
      // 处理查询条件
      let searchTermsAll = {}
      // 行为集合
      searchTermsAll.searchEvents = []
      for (let one of this.behaviors) {
        searchTermsAll.searchEvents.push({
          event: one.event,
          behaviorName: one.behaviorName,
          secAttr: one.event[1],
          eventAttributeList: one.eventAttributeList,
          eventLimitAttr: one.eventLimitAttr,
          eventAttrOptions: one.eventAttrOptions,
          generation_time: one.generation_time,
          generationTime: one.generation_time,
          dateRange: {
            operator: one.generation_time_relation,
            type: one.generation_time_type,
            value: one.generation_time_value,
            from: one.generation_time_value_start,
            to: one.generation_time_value_end
          }
        })
      }
      // 行为时间
      searchTermsAll.date_interval = {
        date_interval_type: this.eventSearchDateSelect,
        date_interval_start: this.eventSearchDateSelectStart,
        date_interval_end: this.eventSearchDateSelectEnd
      }
      searchTermsAll.searchPeople = this.formInline.analyse_people
      // 处理高级查询传来的条件
      let termsSend = JSON.parse(JSON.stringify(this.realAllTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'attr') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'aud_portary') {
            str = 'tag'
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'customer_kpi') {
            str = one.selectedOptions[1].split('@')[0]
          }
          // 处理生日为字符串
          if (one.selectedOptions[0] === 'attr' && one.selectedOptions[1].split('@')[1] === 'datePicker') {
            let d = new Date(one.value)
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            let day = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
            one.value = d.getFullYear() + '-' + month + '-' + day
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'wechat_open_id') {
            str = one.selectedOptions[1].split('@')[0]
          }
          let firAttr = one.selectedOptions[0] === 'wechat_open_id' ? 'attr' : one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str
          delete one.relationOptions
          delete one.options
          if (one.attr !== 'event') {
            delete one.eventAttrOptions
            delete one.option
          }
          // 判断是否事件
          if (one.selectedOptions[0] === 'event') {
            delete one.relationOptions
            delete one.option
            delete one.eventAttributeList
          }
          // 处理事件
          // if (one.selectedOptions[0] === 'event' && one.eventLimitAttr === true) {
          // eventAttrArr = one.eventAttrOptions
          // }
        }
      }
      searchTermsAll.search = termsSend
      searchTermsAll.searchQuota = this.analyseQuotaData
      // 判断维度至少有一个是有条件的
      let analyseDimensionDataCount = 0
      for (let one of this.analyseDimensionData) {
        if (one.dimension.length > 0) {
          analyseDimensionDataCount = analyseDimensionDataCount + 1
        }
      }
      if (analyseDimensionDataCount === 0) {
        _g.toastMsg('error', '请保证维度至少有一个具体条件')
        return
      }
      searchTermsAll.searchDimension = this.analyseDimensionData
      searchTermsAll.modelId = this.formInline.modelId
      // 处理参数
      let data = {}
      data.type = 2
      data.name = this.otherSaveForm.name
      data.modelId = this.formInline.modelId
      let terms = JSON.stringify(searchTermsAll)
      data.filterJson = terms
      data = JSON.stringify(data)
      analyseSaveSingle(data).then((res) => {
        if (res.data.code === '200') {
          this.otherSaveSingleDialog = false
          _g.toastMsg('success', '另存成功')
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 暂存单图名字
    saveSingleNameOnly () {
      this.showSingleName = false
      this.editSingleNameShow = this.editSingleName
    },
    // 显示保存名字的input
    openEditName () {
      this.showSingleName = true
      this.editSingleName = this.editSingleNameShow
    },
    // 另存为弹窗
    otherSave () {
      this.otherSaveSingleDialog = true
    },
    // 编辑保存
    editSave () {
      // 判断行为
      for (let one of this.behaviors) {
        if (one.behaviorName === '') {
          _g.toastMsg('error', '行为名称不允许为空')
          return
        }
        if (one.generation_time === true) {
          if (one.generation_time_type === '') {
            _g.toastMsg('error', '周期时间类型不允许为空')
            return
          }
          if (one.generation_time_relation === '') {
            _g.toastMsg('error', '周期时间相对关系不允许为空')
            return
          }
          if (one.generation_time_relation !== 'gtele') {
            if (one.generation_time_value === '') {
              _g.toastMsg('error', '周期时间值不允许为空')
              return
            }
          }
          if (one.generation_time_relation === 'gtele') {
            if (one.generation_time_value_start === '' || one.generation_time_value_end === '') {
              _g.toastMsg('error', '周期时间区间值不允许为空')
              return
            }
          }
        }
      }
      let searchTermsAll = {}
      // 行为集合
      searchTermsAll.searchEvents = []
      for (let one of this.behaviors) {
        searchTermsAll.searchEvents.push({
          event: one.event,
          behaviorName: one.behaviorName,
          secAttr: one.event[1],
          eventAttributeList: one.eventAttributeList,
          eventLimitAttr: one.eventLimitAttr,
          eventAttrOptions: one.eventAttrOptions,
          generation_time: one.generation_time,
          generationTime: one.generation_time,
          dateRange: {
            operator: one.generation_time_relation,
            type: one.generation_time_type,
            value: one.generation_time_value,
            from: one.generation_time_value_start,
            to: one.generation_time_value_end
          }
        })
      }
      // 行为时间
      searchTermsAll.date_interval = {
        date_interval_type: this.eventSearchDateSelect,
        date_interval_start: this.eventSearchDateSelectStart,
        date_interval_end: this.eventSearchDateSelectEnd
      }
      searchTermsAll.searchPeople = this.formInline.analyse_people
      // 处理高级查询传来的条件
      let termsSend = JSON.parse(JSON.stringify(this.realAllTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'attr') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'group') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'aud_portary') {
            str = 'tag'
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'customer_kpi') {
            str = one.selectedOptions[1].split('@')[0]
          }
          // 处理生日为字符串
          if (one.selectedOptions[0] === 'attr' && one.selectedOptions[1].split('@')[1] === 'datePicker') {
            let d = new Date(one.value)
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            let day = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
            one.value = d.getFullYear() + '-' + month + '-' + day
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'wechat_open_id') {
            str = one.selectedOptions[1].split('@')[0]
          }
          let firAttr = one.selectedOptions[0] === 'wechat_open_id' ? 'attr' : one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str
          delete one.relationOptions
          delete one.options
          if (one.attr !== 'event') {
            delete one.eventAttrOptions
            delete one.option
          }
          // 判断是否事件
          if (one.selectedOptions[0] === 'event') {
            delete one.relationOptions
            delete one.option
            delete one.eventAttributeList
          }
          // 处理事件
          if (one.selectedOptions[0] === 'event' && one.eventLimitAttr === true) {
            // eventAttrArr = one.eventAttrOptions
          }
        }
      }
      searchTermsAll.search = termsSend

      searchTermsAll.searchQuota = this.analyseQuotaData
      // 判断维度至少有一个是有条件的
      let analyseDimensionDataCount = 0
      for (let one of this.analyseDimensionData) {
        if (one.dimension.length > 0) {
          analyseDimensionDataCount = analyseDimensionDataCount + 1
        }
      }
      if (analyseDimensionDataCount === 0) {
        _g.toastMsg('error', '请保证维度至少有一个具体条件')
        return
      }
      searchTermsAll.modelId = this.formInline.modelId
      searchTermsAll.searchDimension = this.analyseDimensionData
      customerAnalyseSingleEdit(this.editId, this.editSingleName, JSON.stringify(searchTermsAll), this.formInline.modelId).then((res) => {
        if (res.data.code === '200') {
          _g.toastMsg('success', '保存成功')
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 打开单图弹窗
    openSave () {
      this.saveSingleDialog = true
    },
    // 保存为单图
    confirmSave () {
      // 判断行为
      for (let one of this.behaviors) {
        if (one.behaviorName === '') {
          _g.toastMsg('error', '行为名称不允许为空')
          return
        }
        if (one.generation_time === true) {
          if (one.generation_time_type === '') {
            _g.toastMsg('error', '周期时间类型不允许为空')
            return
          }
          if (one.generation_time_relation === '') {
            _g.toastMsg('error', '周期时间相对关系不允许为空')
            return
          }
          if (one.generation_time_relation !== 'gtele') {
            if (one.generation_time_value === '') {
              _g.toastMsg('error', '周期时间值不允许为空')
              return
            }
          }
          if (one.generation_time_relation === 'gtele') {
            if (one.generation_time_value_start === '' || one.generation_time_value_end === '') {
              _g.toastMsg('error', '周期时间区间值不允许为空')
              return
            }
          }
        }
      }
      // 处理查询条件
      let searchTermsAll = {}
      // 行为集合
      searchTermsAll.searchEvents = []
      for (let one of this.behaviors) {
        searchTermsAll.searchEvents.push({
          event: one.event,
          behaviorName: one.behaviorName,
          secAttr: one.event[1],
          eventAttributeList: one.eventAttributeList,
          eventLimitAttr: one.eventLimitAttr,
          eventAttrOptions: one.eventAttrOptions,
          generation_time: one.generation_time,
          generationTime: one.generation_time,
          dateRange: {
            operator: one.generation_time_relation,
            type: one.generation_time_type,
            value: one.generation_time_value,
            from: one.generation_time_value_start,
            to: one.generation_time_value_end
          }
        })
      }
      // 行为时间
      searchTermsAll.date_interval = {
        date_interval_type: this.eventSearchDateSelect,
        date_interval_start: this.eventSearchDateSelectStart,
        date_interval_end: this.eventSearchDateSelectEnd
      }
      searchTermsAll.searchPeople = this.formInline.analyse_people
      // 处理高级查询传来的条件
      let termsSend = JSON.parse(JSON.stringify(this.realAllTerms))
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'attr') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'group') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'aud_portary') {
            str = 'tag'
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'wechat_open_id') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'customer_kpi') {
            str = one.selectedOptions[1].split('@')[0]
          }
          // 处理生日为字符串
          if (one.selectedOptions[0] === 'attr' && one.selectedOptions[1].split('@')[1] === 'datePicker') {
            let d = new Date(one.value)
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            let day = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
            one.value = d.getFullYear() + '-' + month + '-' + day
          }
          one.attr = one.selectedOptions[0] === 'wechat_open_id' ? 'attr' : one.selectedOptions[0]
          one.secAttr = str
          // delete one.relationOptions
          // delete one.options
          if (one.attr !== 'event') {
            // delete one.eventAttrOptions
            // delete one.option
          }
          // 处理事件eventAttributeList
          if (one.selectedOptions[0] === 'event' && one.eventLimitAttr === true) {
            // eventAttrArr = one.eventAttrOptions
          }
        }
      }
      searchTermsAll.search = termsSend
      searchTermsAll.searchQuota = this.analyseQuotaData
      // 判断维度至少有一个是有条件的
      let analyseDimensionDataCount = 0
      for (let one of this.analyseDimensionData) {
        if (one.dimension.length > 0) {
          analyseDimensionDataCount = analyseDimensionDataCount + 1
        }
      }
      if (analyseDimensionDataCount === 0) {
        _g.toastMsg('error', '请保证维度至少有一个具体条件')
        return
      }
      searchTermsAll.searchDimension = this.analyseDimensionData
      searchTermsAll.modelId = this.formInline.modelId
      // 处理参数
      let data = {}
      data.type = 2
      data.name = this.saveForm.name
      data.modelId = this.formInline.modelId
      let terms = JSON.stringify(searchTermsAll)
      data.filterJson = terms
      data = JSON.stringify(data)
      let layoutArr = JSON.parse(this.myStorage.getItem('itemLayout'))
      let idArray = JSON.parse(this.myStorage.getItem('itemFigures'))
      let maxY = 0
      if (layoutArr && layoutArr.length >= 2) {
        for (let x = 0; x < layoutArr.length - 1; x++) {
          if (layoutArr[x].y !== null) {
            maxY = maxY < layoutArr[x + 1].y ? layoutArr[x + 1].y : maxY
          }
        }
      }
      analyseSaveSingle(data).then((res) => {
        if (res.data.code === '200') {
          this.saveSingleDialog = false
          if (this.isAdd === 'true') {
            idArray.push({
              id: res.data.result.id,
              name: res.data.result.name,
              position: [0, maxY + 6, 9, 6],
              type: res.data.result.type
            })
            layoutArr.push({
              'x': 0,
              'y': maxY + 6,
              'w': 9,
              'h': 6,
              'i': res.data.result.id,
              'showType': '',
              'type': res.data.result.type,
              'name': res.data.result.name
            })
            this.myStorage.setItem('itemLayout', JSON.stringify(layoutArr))
            this.myStorage.setItem('itemFigures', JSON.stringify(idArray))
            this.addSingleChartAction(res.data.result.id)
            _g.toastMsg('success', '保存成功')
            router.push({ path: '/home/board-list' })
            this.myStorage.setItem('borderDetailsIsAdd', 'false')
          }
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    addSingleChartAction (singleId) {
      addSingleChartToDashBoard(this.dashBoardId, singleId).then(res => {
        if (res.data.code === '200') {
          console.log('添加单图成功')
        } else {
          console.log('添加单图失败')
        }
      })
    },
    // 选择自定义时间
    setTimeYr () {
      this.eventSearchDateSelect = 'cstm'
      this.start_end_time = '自定义时间'
      this.visible2 = false
      this.gridNum = true
    },
    // 选择起止时间类型
    chooseTimeType (l) {
      this.start_end_time = l.label
      this.visible2 = false
      this.eventSearchDateSelect = l.value
      this.gridNum = false
    },
    // 删除一个行为
    removeBehaviorItem (index, i) {
      this.behaviors.splice(index, 1)
      if (this.behaviors.length === 0) {
        this.behaviors.splice(i, 1)
      }
      // 分析维度  分析指标先初始化
      this.handleInitData()
      this.eventIdObj[index] = ''
      this.$nextTick(() => {
        // 处理这些事件id  去获取分析维护，事件的二级下拉
        this.handleAnalyseBehaviorEventId()
        // 获取分析指标金额和数量二级下拉
        this.getAnalyseTarge()
      })
    },
    // 增加一个行为
    addNewBehavior () {
      if (this.checkSameCount > 1) {
        this.checkSameCount = 0
        return
      }
      for (let one of this.behaviors) {
        if (one.behaviorName === '') {
          _g.toastMsg('error', '行为名称不允许为空')
          return
        }
        if (one.generation_time === true) {
          if (one.generation_time_type === '') {
            _g.toastMsg('error', '周期时间类型不允许为空')
            return
          }
          if (one.generation_time_relation === '') {
            _g.toastMsg('error', '周期时间相对关系不允许为空')
            return
          }
          if (one.generation_time_relation !== 'gtele') {
            if (one.generation_time_value === '') {
              _g.toastMsg('error', '周期时间值不允许为空')
              return
            }
          }
          if (one.generation_time_relation === 'gtele') {
            if (one.generation_time_value_start === '' || one.generation_time_value_end === '') {
              _g.toastMsg('error', '周期时间区间值不允许为空')
              return
            }
          }
        }
      }
      this.behaviors.push({
        eventsSelectOptions: [],
        behaviorName: '行为名称1',
        event: ['0@', 'anyone'], // 'anyone@none'
        event_about: '',
        original_id: '',
        qrcode: '',
        generation_time_type: '',
        generation_time_relation: '',
        generation_time_value: '',
        generation_time_value_start: '',
        generation_time_value_end: '',
        generation_time_values: [],
        generation_time: false,
        eventLimitAttr: false,
        eventAttributeOptions: [ // 选择受众事件选中事件属性
          {
            attributeSelect: '',
            attributeRelation: '',
            attributeValue: ''
          }
        ],
        eventAttributeList: [],
        selectedOptions: ['attr', 'realname@input'],
        eventAttrOptions: [
          {
            attributeContent: '',
            relationOptions: [],
            sources: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attr_type: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValueStart: '',
            attributeValueEnd: '',
            attributeValue: ''
          }
        ],
        relationOptions: [
          {
            value: 'equal',
            label: '等于'
          }, {
            value: 'not_equal',
            label: '不等于'
          }, {
            value: 'contain',
            label: '包含'
          }, {
            value: 'not_contain',
            label: '不包含'
          }, {
            value: 'empty',
            label: '为空'
          },
          {
            value: 'not_empty',
            label: '不为空'
          }
        ]
      })
      this.handleInitData()
    },
    // 初始化  分析维度和分析指标
    handleInitData () {
      this.analyseDimensionData = [
        {
          dimension: ['']
        }
      ]
      this.analyseDimensionOptions = BEHAVIOR_DIMENSION_OPS()
      const list = JSON.parse(JSON.stringify(this.personChildren))
      this.analyseDimensionOptions[1].children = list
      this.analyseQuotaData = [
        {
          searchQuota: ['total_number_people']
        }
      ]
      this.analyseQuotaOptions = ANALYSE_SE_QUO_INIT_OPS()
    },
    // 切换区间结束值
    chooseGenerationTimeValuesEnd (val) {
      this.generation_time_value_end_use = val
    },
    // 清除区间结束值
    clearGenerationTimeValuesEnd (item) {
    },
    // 切换区间开始值
    chooseGenerationTimeValuesStart (item) {
      console.log('chooseGenerationTimeValuesStart', item)
      // 月的时候
      if (item.generation_time_type_use === 'month') {
        let arr = JSON.parse(JSON.stringify(this.generation_time_value_month))
        arr.splice(0, item.generation_time_value_start)
        item.generation_time_values_end = arr
      }
      if (item.generation_time_value_start === 'last') {
        this.generation_time_values_end = []
        item.generation_time_value_end = ''
      }
      // 周的时候
      if (this.generation_time_type_use === 'week') {
        let arr = JSON.parse(JSON.stringify(this.generation_time_value_week))
        arr.splice(0, item.generation_time_value_start)
        item.generation_time_values_end = arr
        if (item.generation_time_value_start === '7') {
          item.generation_time_values_end = []
          item.generation_time_value_end = ''
        }
      }
      if (parseInt(item.generation_time_value_start) > parseInt(item.generation_time_value_end)) {
        item.generation_time_value_end = ''
      }
    },
    // 切换周期为区间
    chooseGenerationTimeRelation (item) {
      console.log('chooseGenerationTimeRelation', item)
      if (item.generation_time_type === 'month') {
        item.generation_time_values = this.generation_time_value_month
      } else if (item.generation_time_type === 'week') {
        item.generation_time_values = this.generation_time_value_week
      }
      item.generation_time_value = ''
      item.generation_time_value_start = ''
      item.generation_time_value_end = ''
      if (item.generation_time_type === 'month') {
        item.generation_time_values_start = this.generation_time_value_month
        item.generation_time_values_end = this.generation_time_value_month
      }
      if (item.generation_time_type === 'week') {
        item.generation_time_values_start = this.generation_time_value_week
        item.generation_time_values_end = this.generation_time_value_week
      }
    },
    // 清除时间
    clearGenerationTime (item) {
      item.generation_time_value = ''
      item.generation_time_value_start = ''
      item.generation_time_value_end = ''
    },
    // 切换周期时间
    chooseGenerationTimeType (val) {
      if (val === 'month') {
        this.generation_time_type_use = 'month'
        this.generation_time_values = this.generation_time_value_month
        this.generation_time_values_start = this.generation_time_value_month
        this.generation_time_values_end = this.generation_time_value_month
      }
      if (val === 'week') {
        this.generation_time_type_use = 'week'
        this.generation_time_values = this.generation_time_value_week
        this.generation_time_values_start = this.generation_time_value_week
        this.generation_time_values_end = this.generation_time_value_week
      }
    },
    // 切换事件相关
    changeEventAbout (item) {
      // 如果是微信  将公众号的原始id也放进去
      if (
        item.event.split('@')[0] === 'subscribe' ||
        item.event.split('@')[0] === 'red_packet' ||
        item.event.split('@')[0] === 'public_to_reply' ||
        item.event.split('@')[0] === 'leaving_message' ||
        item.event.split('@')[0] === 'click_menu' ||
        item.event.split('@')[0] === 'scan_qrcode' ||
        item.event.split('@')[0] === 'send_tpl_message' ||
        item.event.split('@')[0] === 'scan_offline_qrcode' ||
        item.event.split('@')[0] === 'unsubscribe'
      ) {
        for (let yi of this.eventAbout) {
          if (yi.id === item.event_about) {
            item.original_id = yi.original_id
          }
        }
      }
      // 处理公众号二维码选择问题
      if (item.event.split('@')[0] === 'scan_qrcode') {
        for (let j in this.eventAbout) {
          if (item.event_about === this.eventAbout[j].id) {
            this.qrcodes = this.eventAbout[j].qrcode
          }
        }
        item.qrcode = ''
      }
    },
    // 切换事件
    changeEvent (event, item, index) {
      let eventId = item.event[0].split('@')[0]
      // 将每个行为的id存成一个对象 分析维度中事件二级下拉需要用eventId集合
      this.eventIdObj[index] = event[1].split('@')[1]
      for (let it of this.eventsSelectOptions) {
        if (it.id === parseInt(eventId)) {
          for (let is of it.children) {
            if (is.value === item.event[1]) {
              item.eventAttributeList = is.eventAttributeList
            }
          }
        }
      }
      // 初始化 分析指标分析维度
      this.handleInitData()
      this.$nextTick(() => {
        // 处理这些事件id  去获取分析维护，事件的二级下拉
        this.handleAnalyseBehaviorEventId()
        // 获取分析指标金额和数量二级下拉
        this.getAnalyseTarge()
      })
    },
    // 获取分析指标金额和数量二级下拉
    getAnalyseTarge () {
      let eventIdList = Object.values(this.eventIdObj)
      // 去除空串
      eventIdList = eventIdList.filter(item => item !== '')
      const eventIds = eventIdList.join(',')
      fetchAnalyseIdentity(eventIds).then(res => {
        const { code, result = [] } = res.data || {}
        if (code === '200') {
          if (result.length > 0) {
            result.forEach(({ type, identityList }) => {
              this.analyseQuotaOptions.forEach(item => {
                if (type === item.value) {
                  item.children = identityList.map(({ disabled, attr_name, attr_identity }) => {
                    return {
                      disabled: false,
                      label: attr_name,
                      value: attr_identity
                    }
                  })
                }
              })
            })
            this.analyseQuotaOptions[2].disabled = !this.analyseQuotaOptions[2].children.length > 0
            this.analyseQuotaOptions[3].disabled = !this.analyseQuotaOptions[3].children.length > 0
          } else {
            this.analyseQuotaOptions = ANALYSE_SE_QUO_INIT_OPS()
          }

        }
      })
    },
    // 处理这些事件id  去获取分析维护，事件的二级下拉
    handleAnalyseBehaviorEventId () {
      let eventIdList = Object.values(this.eventIdObj)
      // 去除空串
      eventIdList = eventIdList.filter(item => item !== '')
      const eventIds = eventIdList.join(',')
      const list = JSON.parse(JSON.stringify(this.personChildren))
      this.analyseDimensionOptions[1].children = list
      analyseDimensionEventIdentity(eventIds).then(res => {
        const { result } = res.data || {}

        this.analyseDimensionOptions[2].disabled = false
        this.analyseDimensionOptions[2].children = result.map(({ attr_name, disabled, attr_identity }) => {
          return {
            value: attr_identity,
            label: attr_name,
            disabled: false
          }
        })
      })
    },

    totals (total, range) {
      total = this.totalCount
      return '共 ' + total + ' 条'
    },
    // 新版分页
    onChange (pageNumber) {
      console.log('Page: ', pageNumber)
    },
    // 饼图
    chartPieOne () {
      this.myChartPie = this.$echarts.init(document.getElementById('chartPie'))
      this.myChartPie.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 20,
          top: 20,
          bottom: 20,
          data: this.chartDataX
        },
        series: [
          {
            name: this.xNamePie,
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'outside'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '20',
                  fontWeight: 'bold'
                }
              }
            },
            itemStyle: {
              color: function (params) {
                var colorList = ['#f5be00', '#00ffb4', '#ff2797', '#9f45fb', '#00f5f2', '#ff4949', '#2cff27', '#fd932b', '#ff5fdf', '#4c61fe', '#ed661c', '#45b0fb', '#3400f5', '#ff8c8c', '#ff2797', '＃acbf5d', '#62bba1', '#80ba4d', '#254fa3', '#fbda78', '#3e9389', '#843583', '#64daff', '#9bc1de', '#7b9df9', '#9ab899', '#fcceac', '#e94b63', '#f073ab', '#6d8345', '#9c95c9', '#cd9a5b', '#decc00', '#d4c59e', '#7d5786', '#95d6da', '#018792', '#b44333', '#d68989', '#fece7a']
                return colorList[params.dataIndex]
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: this.chartDataYPie
          }
        ]
      })
      this.myChartPie.resize()
    },
    // 折线图
    chartLineOne () {
      this.myChartLine = this.$echarts.init(document.getElementById('chartLine'))
      this.myChartLine.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.chartDataX,
          name: this.xNames,
          // axisLabel: {
          //   interval: 0
          // }
        },
        yAxis: {
          type: 'value',
          name: this.yNames
        },
        series: [{
          data: this.chartDataY,
          type: 'line',
          lineStyle: {
            color: '#1980FF'
          },
          areaStyle: {
            normal: {
              color: '#1980FF'
            },
            color: '#CCE3FF'
          },
          itemStyle: {
            normal: {
              color: '#1980FF'
            }
          }
        }]
      })
      this.myChartLine.resize()
    },
    // 柱状图(单柱)
    chartZhuOne () {
      if (this.chartDataX.length <= 10) {
        this.barWidth = '56px'
      }
      if (this.chartDataX.length > 10) {
        this.barWidth = '24px'
      }
      this.myChartZhu = this.$echarts.init(document.getElementById('chartZhu'))
      this.myChartZhu.setOption({
        color: ['#1980FF'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: this.chartDataX,
            axisTick: {
              alignWithLabel: true
            },
            name: this.xNames,
            // axisLabel: {
            //   interval: 0
            // }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.yNames
          }
        ],
        series: [
          {
            name: this.yNames,
            type: 'bar',
            barWidth: this.barWidth,
            data: this.chartDataYBar
          }
        ]
      })
      this.myChartZhu.resize()
    },
    // 柱状图(多柱)
    chartZhuTwo () {
      if (this.chartDataX.length <= 10) {
        this.barWidth = '56px'
      }
      if (this.chartDataX.length > 10) {
        this.barWidth = '24px'
      }
      console.log('10252')
      if (!this.g_two_bar_chart) {
        this.g_two_bar_chart = new G2.Chart({
          container: 'chartZhu',
          forceFit: true,
          height: 300,
          padding: 'auto'
        })
      }
      this.g_two_bar_chart.source(this.chartDataYBar)
      this.g_two_bar_chart.interval().position('type*xsValue').color('xs').opacity(1).adjust([{
        type: 'dodge',
        marginRatio: 1 / 32
      }])
      this.g_two_bar_chart.render()
    },
    // 选择表格查询结果
    chooseTable () {
      this.showType.table.choosed = true
      this.showType.pie.choosed = false
      this.showType.line.choosed = false
      this.showType.zhu.choosed = false
      this.showType.num.choosed = false
    },
    // 选择柱状查询结果
    chooseZhu () {
      this.showType.table.choosed = false
      this.showType.pie.choosed = false
      this.showType.line.choosed = false
      this.showType.zhu.choosed = true
      this.showType.num.choosed = false
      let myChart = document.getElementById('chartZhu')
      myChart.style.width = '100%'
      setTimeout(() => {
        this.chartZhuOne()
      }, 30)
      // if (this.hasMultiChart === 1) {
      // let myChart = document.getElementById('chartZhu')
      // myChart.style.width = '80%'
      // setTimeout(() => {
      // this.chartZhuTwo()
      // }, 30)
      // }
    },
    // 选择线查询结果
    chooseLine () {
      this.showType.table.choosed = false
      this.showType.pie.choosed = false
      this.showType.line.choosed = true
      this.showType.zhu.choosed = false
      this.showType.num.choosed = false
      let myChart = document.getElementById('chartLine')
      myChart.style.width = '100%'
      setTimeout(() => {
        this.chartLineOne()
      }, 30)
    },
    // 选择饼查询结果
    choosePie () {
      this.showType.table.choosed = false
      this.showType.pie.choosed = true
      this.showType.line.choosed = false
      this.showType.zhu.choosed = false
      this.showType.num.choosed = false
      let myChart = document.getElementById('chartPie')
      myChart.style.width = '100%'
      setTimeout(() => {
        this.chartPieOne()
      }, 30)
    },
    // 选择数字查询结果
    chooseNum () {
      this.showType.table.choosed = false
      this.showType.pie.choosed = false
      this.showType.line.choosed = false
      this.showType.zhu.choosed = false
      this.showType.num.choosed = true
    },
    // 开始查询
    startSearch () {
      // 判断行为
      for (let one of this.behaviors) {
        if (one.behaviorName === '') {
          _g.toastMsg('error', '行为名称不允许为空')
          return
        }
        if (one.generation_time === true) {
          if (one.generation_time_type === '') {
            _g.toastMsg('error', '周期时间类型不允许为空')
            return
          }
          if (one.generation_time_relation === '') {
            _g.toastMsg('error', '周期时间相对关系不允许为空')
            return
          }
          if (one.generation_time_relation !== 'gtele') {
            if (one.generation_time_value === '') {
              _g.toastMsg('error', '周期时间值不允许为空')
              return
            }
          }
          if (one.generation_time_relation === 'gtele') {
            if (one.generation_time_value_start === '' || one.generation_time_value_end === '') {
              _g.toastMsg('error', '周期时间区间值不允许为空')
              return
            }
          }
        }
      }
      // 判断维度至少有一个是有条件的
      let analyseDimensionDataCount = 0
      for (let one of this.analyseDimensionData) {
        if (one.dimension.length > 0) {
          analyseDimensionDataCount = analyseDimensionDataCount + 1
        }
      }
      if (analyseDimensionDataCount === 0) {
        _g.toastMsg('error', '请保证维度至少有一个具体条件')
        return
      }
      this.loading = true
      this.showType.table.is_have = false
      this.showType.zhu.is_have = false
      this.showType.line.is_have = false
      this.showType.pie.is_have = false
      this.showType.num.is_have = false
      let searchTermsAll = {}
      // 行为集合
      searchTermsAll.searchEvents = []
      let behavior = JSON.parse(JSON.stringify(this.behaviors))
      for (let one of behavior) {
        for (let two of one.eventAttrOptions) {
          delete two.relationOptions
          delete two.sources
          delete two.eventAttrValueOptions
        }
        searchTermsAll.searchEvents.push({
          behaviorName: one.behaviorName,
          secAttr: one.event[1],
          eventAttrOptions: one.eventAttrOptions,
          generationTime: one.generation_time,
          dateRange: {
            operator: one.generation_time_relation,
            type: one.generation_time_type,
            value: one.generation_time_value,
            from: one.generation_time_value_start,
            to: one.generation_time_value_end
          }
        })
      }
      for (let search of searchTermsAll.searchEvents) {
        if (search.generationTime === false) {
          search.dateRange = {
            operator: '',
            type: '',
            value: '',
            from: '',
            to: ''
          }
        }
      }
      // 行为时间
      searchTermsAll.date_interval = {
        date_interval_type: this.eventSearchDateSelect,
        date_interval_start: this.eventSearchDateSelectStart,
        date_interval_end: this.eventSearchDateSelectEnd
      }
      searchTermsAll.searchPeople = this.formInline.analyse_people
      // 处理高级查询传来的条件
      let termsSend = JSON.parse(JSON.stringify(this.realAllTerms))
      // 高级查询 eventAttrOptions 属性放到行为分析里
      let eventAttrArr = []
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'attr') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'group') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'aud_portary') {
            str = 'tag'
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'customer_kpi') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'wechat_open_id') {
            str = one.selectedOptions[1].split('@')[0]
          }
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'follow_public') {
            str = one.selectedOptions[1].split('@')[0]
          }
          // 处理生日为字符串
          if (one.selectedOptions[0] === 'attr' && one.selectedOptions[1].split('@')[1] === 'datePicker') {
            let d = new Date(one.value)
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            let day = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
            one.value = d.getFullYear() + '-' + month + '-' + day
          }
          one.attr = one.selectedOptions[0] === 'wechat_open_id' ? 'attr' : one.selectedOptions[0]
          one.secAttr = str
          delete one.relationOptions
          delete one.options
          if (one.attr !== 'event') {
            delete one.eventAttrOptions
            delete one.option
          }
          // 判断是否事件
          if (one.selectedOptions[0] === 'event') {
            delete one.relationOptions
            delete one.option
            delete one.eventAttributeList
          }
          // 处理事件
          // if (one.selectedOptions[0] === 'event' && one.eventLimitAttr === true) {
          // eventAttrArr = one.eventAttrOptions
          // }
        }
      }
      searchTermsAll.search = termsSend
      searchTermsAll.searchQuota = this.analyseQuotaData
      searchTermsAll.modelId = this.formInline.modelId
      searchTermsAll.searchDimension = this.analyseDimensionData
      behaviorAnalyseSearch(searchTermsAll).then((res) => {
        if (res.data.code === '200') {
          console.log(res.data, 'res.data拿到数据========')
          this.showType.table.choosed = true
          this.showType.zhu.choosed = true
          this.showType.line.choosed = true
          this.showType.pie.choosed = true
          this.showType.num.choosed = true
          // 判断默认选中
          if (res.data.result.defaultShow === 'table') {
            this.showType.table.choosed = true
            this.showType.zhu.choosed = false
            this.showType.line.choosed = false
            this.showType.pie.choosed = false
            this.showType.num.choosed = false
          }
          if (res.data.result.defaultShow === 'barGraph') {
            this.showType.table.choosed = false
            this.showType.zhu.choosed = true
            this.showType.line.choosed = false
            this.showType.pie.choosed = false
            this.showType.num.choosed = false
          }
          if (res.data.result.defaultShow === 'lineChart') {
            this.showType.table.choosed = false
            this.showType.zhu.choosed = false
            this.showType.line.choosed = true
            this.showType.pie.choosed = false
            this.showType.num.choosed = false
          }
          if (res.data.result.defaultShow === 'pieChart') {
            this.showType.table.choosed = false
            this.showType.zhu.choosed = false
            this.showType.line.choosed = false
            this.showType.pie.choosed = true
            this.showType.num.choosed = false
          }
          if (res.data.result.defaultShow === 'singleMetric') {
            this.showType.table.choosed = false
            this.showType.zhu.choosed = false
            this.showType.line.choosed = false
            this.showType.pie.choosed = false
            this.showType.num.choosed = true
          }
          // 如果只有单值
          if (res.data.result.hasSingleMetric === 1) {
            this.resultNum = res.data.result.singleMetric
            this.showType.num.is_have = true
          }
          // 如果只有表格
          if (res.data.result.hasTable === 1) {
            this.columns = res.data.result.tableData.columns
            this.tableData = res.data.result.tableData.tableData
            this.totalCount = res.data.result.tableData.total
            this.excelData = res.data.result.excelData
            this.showType.table.is_have = true
          }
          // 如果只有柱状图
          if (res.data.result.hasBarGraph === 1) {
            this.hasMultiChart = 0
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push(item.y)
            }
            this.chartDataX = xData
            this.chartDataYBar = yData
            this.showType.zhu.is_have = true
            this.xNames = res.data.result.barLinePieData.xName
            this.yNames = res.data.result.barLinePieData.yName
            let myChart = document.getElementById('chartZhu')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartZhuOne()
            }, 30)
          }
          // 如果只有饼状图
          if (res.data.result.hasPieChart === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push({
                value: item.y,
                name: item.x
              })
            }
            this.chartDataX = xData
            this.chartDataYPie = yData
            this.xNamePie = res.data.result.barLinePieData.xName
            this.showType.pie.is_have = true
            let myChart = document.getElementById('chartPie')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartPieOne()
            }, 30)
          }
          // 如果只有折线图
          if (res.data.result.hasLineChart === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push(item.y)
            }
            this.chartDataX = xData
            this.chartDataY = yData
            this.showType.line.is_have = true
            this.xNames = res.data.result.barLinePieData.xName
            this.yNames = res.data.result.barLinePieData.yName
            let myChart = document.getElementById('chartLine')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartLineOne()
            }, 30)
          }
          this.showResult = true
          this.loading = false
        } else {
          _g.toastMsg('error', res.data.message)
          this.loading = false
        }
      })
    },
    // 添加维度
    addAnalyseDimension () {
      this.analyseDimensionData.push({
        dimension: []
      })
      this.changeDimension(this.analyseDimensionData[0].dimension, 'add')
    },
    // 删除维度
    removeDimensionItem (two, j) {
      if (this.analyseDimensionData.length === 1) {

        return
      }
      this.analyseDimensionData.splice(j, 1)
      for (let one of this.analyseDimensionOptions) {
        if (one.children) {
          for (let item of one.children) {
            if (two.dimension[1] === item.value) {
              item.disabled = false
            }
          }
        } else {
          if (one.value === two.dimension[0]) {
            one.disabled = false
          }
        }
      }
      if (this.analyseDimensionData.length === 1) {
        this.analyseDimensionOptions = BEHAVIOR_DIMENSION_OPS()
        const list = JSON.parse(JSON.stringify(this.personChildren))
        this.analyseDimensionOptions[1].children = list
        // 处理这些事件id  去获取分析维护，事件的二级下拉
        this.handleAnalyseBehaviorEventId()
        this.changeDimension(this.analyseDimensionData[0].dimension)
      }
    },
    // 切换维度
    changeDimension (val, key) {
      const value = val[0]
      this.analyseDimensionOptions.forEach(one => {
        if (key) {
          if (one.value !== value) {
            one.disabled = true
          }
        }
        if (one.children) {
          one.children.forEach(item => {
            item.disabled = false
            this.analyseDimensionData.forEach(k => {
              if (item.value === k.dimension[1]) {
                item.disabled = true
              }
            })
          })
        } else {
          one.disabled = false
          this.analyseDimensionData.forEach(k => {
            if (one.value === k.dimension[1]) {
              one.disabled = true
            }
          })
        }
      })
    },
    // 删除指标
    removeQuotaItem (ele, i) {
      if (this.analyseQuotaData.length === 1) {
        return
      }
      this.analyseQuotaData.splice(i, 1)
      for (let one of this.analyseQuotaOptions) {
        if (one.children) {
          for (let item of one.children) {
            if (ele.searchQuota[1] === item.value) {
              item.disabled = false
              one.disabled = false
            }
          }
        } else {
          if (one.value === ele.searchQuota[0]) {
            one.disabled = false
          }
        }
      }
    },
    // 添加指标
    addAnalyseQuota () {
      this.analyseQuotaData.push({
        searchQuota: []
      })
    },
    // 切换指标
    changeSearchQuota (val) {
      this.analyseQuotaOptions.forEach(one => {
        if (one.children) {
          one.children.forEach(item => {
            one.disabled = false
            item.disabled = false
            this.analyseQuotaData.forEach(ele => {
              if (item.value === ele.searchQuota[1]) {
                item.disabled = true
                one.disabled = true

              }
            })
          })
        } else {
          one.disabled = false
          this.analyseQuotaData.forEach(ele => {
            if (one.value === ele.searchQuota[0]) {
              one.disabled = true
            }
          })
        }
      })
    },
    // 获取子组件的查询条件
    getAllTerms (value) {
      this.allTerms = value
    },
    // 导出
    exporeAction () {
      let str = ''
      console.log('this.excelData66666666', this.excelData)
      for (let item of this.columns) {
        str = str + item.title + ','
      }
      str = str.substring(0, str.lastIndexOf(','))
      str = str + '\n'
      console.log('str', str)
      // 增加\t为了不让表格显示科学计数法或者其他格式
      for (let excelItem of this.excelData) {
        let tmpArray = []
        for (let key in excelItem) {
          let tmp = excelItem[key] + ''
          tmp = tmp.replace(/,/g, '')
          tmpArray.push(tmp)
        }
        str += tmpArray.join(',') + '\n'
        console.log('tmpArray', tmpArray)
        console.log('str', str)
      }
      // encodeURIComponent解决中文乱码
      let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
      // 通过创建a标签实现
      let link = document.createElement('a')
      link.href = uri
      // 对下载的文件命名
      link.download = '数据表.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 加载
    load () {
      this.loading = true
      // 获取属性列表
      // let getAttr = getCusAttrList(this.formInline.modelId)
      // 获取公众号列表
      let loadWechatPublicList = getWechatPublicListForNode(1, '')
      // 获取微页面列表
      let loadWepageList = getWePagesListForNode(1, '')
      // 获取短信列表
      let loadSmsList = getMessageListForNode(1, '')
      // 获取大转盘列表
      let loadBigWheelList = getBigWheelList()
      // 获取事件列表
      let loadEvent = getCusEventList(1, 0, '')
      // let loadEvent = getCustomerEventList(1, '')
      // 请求受众来源
      let loadSource = getSourceData()
      // 发送promiss请求并处理
      Promise.all([loadWechatPublicList, loadWepageList, loadSmsList, loadBigWheelList, loadEvent, loadSource]).then(res => {
        // 处理属性
        // if (res[0].data.code === '200') {
        //   let data = res[1].data.result
        //   let remainData = []
        //   // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
        //   for (let i in data) {
        //     if (data[i].type === 'radio') {
        //       data[i].type = 'select'
        //     }
        //     if (data[i].type === 'checkBox') {
        //       continue
        //     }
        //     if (data[i].is_system === 0) {
        //       continue
        //     }
        //     if (data[i].identity === 'country' || data[i].identity === 'update_time') {
        //       continue
        //     }
        //     remainData.push(data[i])
        //   }
        //   // 拼接处理获得的属性列表到本地数据
        //   for (let i in remainData) {
        //     remainData[i].value = remainData[i].identity + '@' + remainData[i].type
        //     remainData[i].label = remainData[i].name
        //   }
        //   this.analyseDimensionOptions[1].children = remainData
        //   console.log('remainData', remainData)
        // }
        // 处理公众号列表
        if (res[0].data.code === 0) {
          for (let item of res[0].data.data.list) {
            item.label = item.nick_name
            item.value = item.id
          }
          this.wechatPublic = res[0].data.data.list
          for (let item of res[0].data.data.list) {
            this.wechatUse[item.id] = item.nick_name
          }
        }
        // 处理微页面
        if (res[1].data.code === 0) {
          for (let item of res[1].data.data.list) {
            item.label = item.admin_title
            item.value = item.id
          }
          this.wepage = res[1].data.data.list
          for (let item of res[1].data.data.list) {
            this.wepageUse[item.id] = item.admin_title
          }
        }
        // 处理短信
        if (res[2].data.code === 0) {
          for (let item of res[2].data.data.list) {
            item.label = item.sms_name
            item.value = item.id
          }
          this.sms = res[2].data.data.list
          for (let item of res[2].data.data.list) {
            this.smsUse[item.id] = item.sms_name
          }
        }
        // 处理受众事件
        if (res[4].data.code === '200') {
          let data = res[4].data.result.list
          let datas = JSON.parse(JSON.stringify(res[4].data.result.list))
          for (let i of datas) {
            this.eventsShow[i.identity] = i.name
          }
          // 拼接处理获得的事件列表到本地数据
          let remainData = []
          getCusEventGroupList().then((resp) => {
            if (resp.data.code == '200') {
              // 设置分组
              resp.data.result.unshift({
                id: 0,
                name: '全部'
              })
              for (let item of resp.data.result) {
                item.children = []
                item.label = item.name
                item.value = item.id + '@'
              }
              // 普通分组事件
              for (let one of res[4].data.result.list) {
                for (let item of resp.data.result) {
                  if (one.groupId == item.id) {
                    item.children.push({
                      label: one.name,
                      value: `${one.identity}@${one.id}`,
                      id: one.id,
                      eventAttributeList: JSON.parse(one.attr)
                    })
                  }
                }
              }
              // 全部分组事件
              resp.data.result[0].children = []
              resp.data.result[0].children.push({
                label: '不限',
                value: 'anyone'
              })
              for (let one of res[4].data.result.list) {
                resp.data.result[0].children.push({
                  label: one.name,
                  value: `${one.identity}@${one.id}`,
                  id: one.id,
                  eventAttributeList: JSON.parse(one.attr)
                })
              }
            }
            this.eventsSelectOptions = JSON.parse(JSON.stringify(resp.data.result))
          })
          // 处理回显
          this.editId = this.$route.query.id
          // 取出存下的值
          let queryJsons = sessionStorage.getItem('queryJson')
          this.editSingleNameShow = this.$route.query.name
          this.editSingleName = this.$route.query.name
          if (this.editId !== undefined && queryJsons !== undefined) {
            this.filterName = '修改人群筛选条件'
            this.queryJson = JSON.parse(queryJsons)
            if (this.queryJson.search.termsGroup[0].terms[0].secAttr === '') {
              this.is_show_analyse_show = false
            }
            if (this.queryJson.search.termsGroup[0].terms[0].secAttr !== '') {
              this.is_show_analyse_show = true
            }
            // 结果存储的数据处理行为
            this.formInline.modelId = this.queryJson.modelId
            // 处理事件
            // 处理事件回显
            this.loadAudGroupAndDimension()
            this.behaviors = []
            for (let one of this.queryJson.searchEvents) {
              let dateTypeArr = []
              if (one.dateRange.type === 'month') {
                dateTypeArr = this.generation_time_value_month
              } else if (one.dateRange.type === 'week') {
                dateTypeArr = this.generation_time_value_week
              }
              this.behaviors.push({
                eventAttrOptions: one.eventAttrOptions,
                event: one.event,
                eventAttributeList: one.eventAttributeList,
                event_about: one.event_about,
                eventLimitAttr: one.eventLimitAttr,
                behaviorName: one.behaviorName,
                generation_time: one.generation_time,
                generation_time_relation: one.dateRange.operator,
                generation_time_type: one.dateRange.type,
                generation_time_values: dateTypeArr,
                generation_time_value: one.dateRange.value,
                generation_time_value_start: one.dateRange.from,
                generation_time_values_start: dateTypeArr,
                generation_time_value_end: one.dateRange.to,
                generation_time_values_end: dateTypeArr,
                generation_time_type_use: 'month'
              })
            }
            this.handleAnalyseChildren()
            // 处理指标回显
            this.handleAnalyseQuota()
            //
            // 处理时间
            if (this.queryJson.date_interval.date_interval_type === 'cstm') {
              this.eventSearchDateSelect = this.queryJson.date_interval.date_interval_type
              this.start_end_time = '自定义时间'
              this.eventSearchDateSelectStart = this.queryJson.date_interval.date_interval_start
              this.eventSearchDateSelectEnd = this.queryJson.date_interval.date_interval_end
            } else {
              this.eventSearchDateSelect = this.queryJson.date_interval.date_interval_type
              for (let item of this.timeTypes) {
                if (this.queryJson.date_interval.date_interval_type === item.value) {
                  this.start_end_time = item.label
                }
              }
            }

            this.handleDimension()
            // 处理筛选条件
            for (let one of this.queryJson.search.termsGroup) {
              for (let item of one.terms) {
                if (
                  (item.selectedOptions[0] === 'attr' &&
                    item.selectedOptions[1].split('@')[1] === 'dateTimePicker') ||
                  (item.selectedOptions[0] === 'attr' &&
                    item.selectedOptions[1].split('@')[1] === 'datePicker')) {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    },
                    {
                      value: 'not_equal',
                      label: '不等于'
                    },
                    {
                      value: 'lt',
                      label: '早于'
                    },
                    {
                      value: 'gt',
                      label: '晚于'
                    },
                    {
                      value: 'gtele',
                      label: '区间'
                    }
                  ]
                }
                if (
                  item.selectedOptions[1].split('@')[1] === 'input') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (
                  item.selectedOptions[1].split('@')[1] === 'select') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (
                  item.selectedOptions[1].split('@')[1] === 'dict') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                  console.log('tem.relationOption', item.relationOptions)
                }
                if (item.selectedOptions[1].split('@')[1] === 'addressPicker') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (item.selectedOptions[1].split('@')[1] === 'multipleSelect') {
                  item.relationOptions = [
                    {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (item.selectedOptions[1].split('@')[1] === 'number') {
                  item.relationOptions = [
                    {
                      value: 'equal',
                      label: '等于'
                    }, {
                      value: 'not_equal',
                      label: '不等于'
                    }, {
                      value: 'gt',
                      label: '大于'
                    }, {
                      value: 'lt',
                      label: '小于'
                    }, {
                      value: 'gtele',
                      label: '区间'
                    }
                  ]
                }
                if (item.selectedOptions[1].split('@')[1] === 'model') {
                  item.relationOptions = [
                    {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'not_contain',
                      label: '不包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not_empty',
                      label: '不为空'
                    }
                  ]
                }
                if (item.selectedOptions[0] === 'aud_portary') {
                  console.log('item.selectedOptions[0]', item.selectedOptions[0])
                  /* -------------自定义属性的相对关系------------ */
                  // 文本
                  if (item.selectedOptions[1].split('@')[0] === 'tag') {
                    item.relationOptions = [
                      {
                        value: 'contain',
                        label: '包含'
                      }, {
                        value: 'not_contain',
                        label: '不包含'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not_empty',
                        label: '不为空'
                      }
                    ]
                  }
                }
                // 来源
                if (item.selectedOptions[1].split('@')[0] === 'source_id') {
                  getCustomerSources(1, 10000, '').then((resb) => {
                    item.option = []
                    for (let b of resb.data.result.list) {
                      item.option.push({
                        name: b.name,
                        id: b.id
                      })
                    }
                  })
                }
                // 来源
                if (item.selectedOptions[1].split('@')[0] === 'stage_id') {
                  getCusStageList(this.formInline.modelId).then((res) => {
                    item.option = [
                      {
                        name: '未知等级',
                        id: 0
                      }
                    ]
                    for (let a of res.data.result) {
                      item.option.push({
                        name: a.name,
                        id: a.id
                      })
                    }
                  })
                }
                //  受众身份
                if (item.selectedOptions[0] === 'wechat_open_id') {
                  /* -------------自定义属性的相对关系------------ */
                  // 文本
                  if (item.selectedOptions[1].split('@')[0] === 'input') {
                    item.relationOptions = [
                      {
                        value: 'equal',
                        label: '等于'
                      }, {
                        value: 'not_equal',
                        label: '不等于'
                      }, {
                        value: 'empty',
                        label: '为空'
                      },
                      {
                        value: 'not_empty',
                        label: '不为空'
                      }
                    ]
                  }
                }
                // 处理群组回显
                if (item.selectedOptions[0] === 'group') {
                  getAudGroupList(this.formInline.modelId, 1, 1000, '', '').then((res) => {
                    for (let j of res.data.result.list) {
                      j.label = j.name
                      j.value = j.id
                    }
                    item.option = res.data.result.list
                  })
                }
              }
            }
            this.allTerms = this.queryJson.search
            sessionStorage.setItem(this.formInline.modelId, JSON.stringify(this.allTerms))
            this.realAllTerms = this.queryJson.search
            console.log(this.realAllTerms, 'this.realAllTerms 33333333')
            this.searchPeople = this.queryJson.searchPeople
            this.allRelationshipSearch = this.queryJson.search.allRelationship
            this.allRelationship = this.queryJson.search.allRelationship
            this.analysePeopleListOne = JSON.parse(JSON.stringify(this.analysePeopleList))
            for (let i of this.analysePeopleListOne) {
              i.label = i.name
              i.value = i.id
            }
            for (let item of this.queryJson.search.termsGroup) {
              for (let one of item.terms) {
                one.option = this.analysePeopleListOne
              }
            }
            getAudGroupList(this.formInline.modelId, 1, 1000, '', '').then(res => {
              this.analysePeopleList = []
              if (res.data.code === '200') {
                // 分析人群
                this.analysePeopleList.push({
                  id: 0,
                  name: '全部'
                })
                for (let f of res.data.result.list) {
                  this.divideGroupShow[f.id] = f.name
                  this.analysePeopleList.push(f)
                }
                this.formInline.analyse_people = this.queryJson.searchPeople
              }
            })
            this.forSonTerms = this.queryJson.search.termsGroup
            // 回显查询
            this.getEdit(this.queryJson)
          }
        }
        // 处理受众来源
        if (res[5].data.code === 0) {
          for (let item of res[5].data.data.list) {
            this.sourceUse[item.id] = item.name
          }
        }
      })
      // 高级查询
      if (this.allRelationship) {
        this.outOperator = this.allRelationship
      } else if (this.allRelationshipSearch) {
        this.outOperator = this.allRelationshipSearch
      }
      this.openLoading()
    },
    // 获取分析行为/分析受众二级下拉
    handleAnalyseChildren () {
      const idList = this.queryJson.searchEvents.map((item, index) => item.secAttr.split('@')[1])
      idList.forEach((item, index) => {
        this.eventIdObj[index] = item
      })
      this.$nextTick(() => {
        // 处理这些事件id  去获取分析维护，事件的二级下拉
        this.handleAnalyseBehaviorEventId()
        // 获取分析指标金额和数量二级下拉
        this.getAnalyseTarge()
      })
    },
    // 处理指标回显
    handleAnalyseQuota () {
      this.analyseQuotaData = this.queryJson.searchQuota
      for (let one of this.analyseQuotaOptions) {
        if (one.children) {
          for (let item of one.children) {
            item.disabled = false
            for (let k of this.queryJson.searchQuota) {
              if (item.value === k.searchQuota[1]) {
                item.disabled = true
              }
            }
          }
        } else {
          one.disabled = false
          for (let k of this.queryJson.searchQuota) {
            if (one.value === k.searchQuota[0]) {
              one.disabled = true
            }
          }
        }
      }
    },
    // 处理维度回显
    handleDimension () {
      // 处理维度
      for (let one of this.analyseDimensionOptions) {
        if (one.children) {
          for (let item of one.children) {
            item.disabled = false
            for (let k of this.queryJson.searchDimension) {
              if (item.value === k.dimension[1]) {
                item.disabled = true
              }
            }
          }
        } else {
          one.disabled = false
          for (let k of this.queryJson.searchDimension) {
            if (one.value === k.dimension[0]) {
              one.disabled = true
            }
          }
        }
      }
      this.analyseDimensionData = this.queryJson.searchDimension
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    loadCustomerStage () {
      console.log(this.formInline.modelId)
      getCusStageList(this.formInline.modelId).then(res => {
        res.data.result.unshift({
          id: 0,
          name: '未知等级'
        })
        for (let item of res.data.result) {
          let id = parseInt(item.id)
          this.stageUse[id] = item.name
        }
      })
    },
    // 获取编辑回显
    getEdit (queryJSON) {
      let query = JSON.parse(JSON.stringify(queryJSON))
      console.log('queryJSON', query.search.termsGroup)
      for (let item of query.search.termsGroup) {
        for (let one of item.terms) {
          if (one.selectedOptions.length > 0 && one.selectedOptions[0] === 'follow_public') {
            one.secAttr = one.selectedOptions[1].split('@')[0]
          }
          delete one.relationOptions
          delete one.option
        }
      }
      behaviorAnalyseSearch(query).then((res) => {
        if (res.data.code === '200') {
          console.log(res.data, 'res.data99999')
          this.showResult = true
          this.showType.table.choosed = true
          this.showType.zhu.choosed = true
          this.showType.line.choosed = true
          this.showType.pie.choosed = true
          this.showType.num.choosed = true
          this.$nextTick(() => {
            // 判断默认选中
            if (res.data.result.defaultShow === 'table') {
              this.showType.table.choosed = true
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'barGraph') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = true
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'lineChart') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = true
              this.showType.pie.choosed = false
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'pieChart') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = true
              this.showType.num.choosed = false
            }
            if (res.data.result.defaultShow === 'singleMetric') {
              this.showType.table.choosed = false
              this.showType.zhu.choosed = false
              this.showType.line.choosed = false
              this.showType.pie.choosed = false
              this.showType.num.choosed = true
            }
          })
          // 如果只有单值
          if (res.data.result.hasSingleMetric === 1) {
            this.resultNum = res.data.result.singleMetric
            this.showType.num.is_have = true
          }
          // 如果只有表格
          if (res.data.result.hasTable === 1) {
            this.columns = res.data.result.tableData.columns
            this.tableData = res.data.result.tableData.tableData
            this.totalCount = res.data.result.tableData.total
            this.excelData = res.data.result.excelData
            this.showType.table.is_have = true
          }
          // 如果只有柱状图
          if (res.data.result.hasBarGraph === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push(item.y)
            }
            this.chartDataX = xData
            this.chartDataYBar = yData
            this.showType.zhu.is_have = true
            this.xNames = res.data.result.barLinePieData.xName
            this.yNames = res.data.result.barLinePieData.yName
            let myChart = document.getElementById('chartZhu')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartZhuOne()
            }, 30)
          }
          // 如果只有饼状图
          if (res.data.result.hasPieChart === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push({
                value: item.y,
                name: item.x
              })
            }
            this.chartDataX = xData
            this.chartDataYPie = yData
            this.xNamePie = res.data.result.barLinePieData.xName
            this.showType.pie.is_have = true
            let myChart = document.getElementById('chartPie')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartPieOne()
            }, 30)
          }
          // 如果只有折线图
          if (res.data.result.hasLineChart === 1) {
            let xData = []
            let yData = []
            for (let item of res.data.result.barLinePieData.valueList) {
              xData.push(item.x)
              yData.push(item.y)
            }
            this.chartDataX = xData
            this.chartDataY = yData
            this.showType.line.is_have = true
            this.xNames = res.data.result.barLinePieData.xName
            this.yNames = res.data.result.barLinePieData.yName
            let myChart = document.getElementById('chartLine')
            myChart.style.width = '100%'
            setTimeout(() => {
              this.chartLineOne()
            }, 30)
          }
        }
      })
    },
    getButtonsList () { // 获取可用菜单按钮列表
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res => {
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr = result.map((item) => {
            return item.perms
          })
          arrObj.map(it => {
            if (newarr.indexOf(it) !== -1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err => {
        this.$message.error(err)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.showType.zhu.choosed = false
      this.showType.line.choosed = false
      this.showType.pie.choosed = false
      this.showType.table.choosed = false
    })
    this.getButtonsList()
  },
  created () {
    this.loadAudGroupList()
    this.initDate()
    this.loadCusTypes()
    this.load()
    this.showType.zhu.choosed = true
    this.showType.line.choosed = true
    this.showType.pie.choosed = true
    this.showType.table.choosed = true
    this.editId = this.$route.query.id
  }
}
</script>

<style scoped>
@media screen and (max-width: 1200px) {
  .behavior-analyse {
  }
}
.analyse-search-icon {
  display: inline-block;
  color: #1980ff;
  transform: transLateY(2px);
  margin-left: 5px;
}
/*显示复杂查询区域*/
.analyse-search-show .big-terms-content {
  position: relative;
}
.analyse-search-show .big-switch-line {
  width: calc(10% - 1px);
  height: calc(100% - 80px);
  position: absolute;
  left: 7.5%;
  top: 20px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
}
.analyse-search-show .big-switch-contents {
  width: 15%;
  position: absolute;
  height: 40px;
  top: calc(50% - 15px);
  margin-top: -20px;
  float: left;
}
.analyse-search-show .big-term-content {
  width: 85%;
  margin-left: 15%;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.arrowPositionSelect,
.ifSelect {
  margin-right: 10px;
}
.search-show-termsGroup {
  margin-left: 10px;
}
.behaviors-limit .el-input__inner {
  font-size: 12px;
}
.add-new-terms {
  text-align: center;
  background-color: #fff;
}
.search-terms-content .big-term-content .search-wrap {
  padding-bottom: 5px;
}
</style>
